import { put, select, takeEvery, all, call, delay, fork, actionChannel, take, takeLatest, spawn } from '@redux-saga/core/effects';
import {
  EDITOR_CREATE_SESSION, EDITOR_SWITCH_BREAKPOINT,
  EDITOR_CREATE_WIDGET, EDITOR_DELETE_WIDGET, EDITOR_UNSELECT_WIDGET,
  EDITOR_SELECT_WIDGET, EDITOR_SELECT_ALL_WIDGETS,  EDITOR_SELECT_WIDGET_RANGE,
  EDITOR_SELECT_PAGE_WIDGET, EDITOR_SELECT_ACTIVE_SEGMENT,
  EDITOR_UPDATE_WIDGET_LAYOUT, EDITOR_BULK_UPDATE_WIDGET_LAYOUT,
  EDITOR_UPDATE_WIDGET_PROPERTY, EDITOR_BULK_UPDATE_WIDGET_PROPERTY, EDITOR_UPDATE_WIDGET_TEMPLATE_PROPERTY,
  EDITOR_UPDATE_WIDGET_ACTIONS,
  EDITOR_UPDATE_PAGE_SETTINGS, EDITOR_UPDATE_WIDGET_CONTENT, EDITOR_UPDATE_THEMES, EDITOR_UPDATE_BRAND_COLORS,
  EDITOR_UPDATE_WIDGET_NAME,
  EDITOR_BULK_UPDATE_WIDGET_ORDER, EDITOR_ARRANGE_WIDGETS,EDITOR_ARRANGE_CAROUSEL_WIDGETS,
  EDITOR_ALIGN_WIDGETS, EDITOR_UPDATE_WIDGET_EDITOR_STATE,
  EDITOR_BULK_UPDATE_WIDGET_EDITOR_STATE,

  EDITOR_ATTACH_TO_CONTAINER,
  EDITOR_RECALCULATE_SECTION_COLUMN_WIDTHS,

  EDITOR_UPDATE_GUIDELINES,
  EDITOR_RECALCULATE_LAYOUT, EDITOR_APPLY_LAYOUT_CHANGES, EDITOR_CALCULATE_PAGE_HEIGHT,
  EDITOR_TOGGLE_EDIT_MODE, EDITOR_TOGGLE_HOTSPOT_VIEW,

  EDITOR_UPDATE_TOOLS_SETTINGS,
  
  EDITOR_INTERACTIVE_CONTENT_CREATE_PAGE, EDITOR_INTERACTIVE_CONTENT_SWITCH_PAGE,

  EDITOR_COPY_WIDGETS, EDITOR_CUT_WIDGETS, EDITOR_CLONE_WIDGETS, EDITOR_CLONE_PAGE,

  EDITOR_FORM_SWITCH_STEP, EDITOR_FORM_INSERT_FIELD,

  SUBMIT_CONTACT_FORM, SUBMIT_OTP_FORM, OTP_RESEND,

  EDITOR_APPLY_WIDGET_PROPERTY_CHANGES, EDITOR_APPLY_BULK_WIDGET_PROPERTY_CHANGES,

  EDITOR_REPLACE_WIDGETS,

  AUTO_GROW_LAYOUT_REQUEST, CREATE_HOTSPOT_WIDGET, EDITOR_CLONE_SLIDE, EDITOR_UPDATE_SPATIAL_SETTING_MODE, EDITOR_UPDATE_APPEARANCE,
  EDITOR_FORM_FIELD_TYPE_CHANGE,   EDITOR_UPDATE_FLIPBOOK_SETTING_MODE,
  
  GENERATE_ALT_TEXT_FOR_WIDGET_REQUEST, GENERATING_ALT_TEXT_FOR_WIDGET_SUCCEEDED, GENERATING_ALT_TEXT_FOR_WIDGET_FAILED,
  EDITOR_CREATE_SEGMENT, EDITOR_SPLIT_PAGE_BY_SELECTION, COPY_PASTE_EDITOR_ANIMATION, AI_MOBILE_OPTIMIZATION_REQUEST, AI_MOBILE_OPTIMIZATION_SUCCEEDED, AI_MOBILE_OPTIMIZATION_FAILED,
  EDITOR_BULK_ATTACH_TO_CONTAINER,
  
  CREATE_WIDGETS_FOR_PROMPT_SECTIONS,
  PROCESS_PROMPT_WIDGET_REQUEST, PROCESSING_PROMPT_WIDGET_SUCCEEDED, 
  PROCESSING_PROMPT_WIDGET_FAILED, PROCESS_ALL_PROMPT_WIDGETS_COMPLETED,
  UPDATE_AI_IMAGE_WIDGET_CONTENT, UPDATE_AI_WIDGET_BACKGROUND,
  CREATE_WIDGET_FROM_HTML_REQUEST,
  CREATE_WIDGET_FROM_HTML_SUCCEEDED,
  CREATE_WIDGET_FROM_HTML_FAILED,
  PROCESS_HTML_TO_WIDGET_REQUEST,
  UPDATE_AI_IMAGE_WIDGET_CONTENT_FAILED
} from 'constants/actionTypes';

import _ from 'lodash';
import { createAction } from 'redux-actions';

import axios from 'axios';
import buildUrl from 'build-url';

import { 
  calculateHeightForWidget, calculationByWidgetType, getBoundingRectForWidget, sortWidgetsByPosition,
  getBoundingRectFromLayout, getWidgetBoundingRectForBreakpoint,
  getBoundingRectForWidgetsAlignment,
  getWidgetVerticalSpanInPage
} from 'components/Editor/helper/layoutManager';
import { recalculateLayoutForBreakpoint } from 'components/Editor/helper/layoutManagerV2';

import { generateWidgetsFromPaletteRequest, getParentGroupWidget, isWidgetInsideGroup, getWidgetType, getWidgetsWithAncestor } from 'components/Editor/helper/widget';
import { groupByActionTypes } from 'redux-undo';
import {
  FORM, FORM_FIELD, OTP_INPUT, FORM_STEP, PAGE, SECTION, SECTION_COLUMN, CONTAINER, GROUP, MODAL,
  CONTENT, CONTENT_CARD, MENU, MENU_CONTAINER, POPUP, HOTSPOT, LIVE_ELEMENT_CONTAINER, 
  CAROUSEL, CONTENT_FILTER, CONTENT_SEARCH, CONTENT_FILTER_CONTAINER, 
  FORM_DROPDOWN_LIST, FORM_CHECK_BOX, FORM_CHECK_LIST, FORM_TEXTAREA, FORM_NUMBER,
  VIDEO, IMAGE, BUTTON, SHAPE, LINE, ASSET, CAROUSEL_CARD, SLIDE, TEXT, HTML, LIVE_ELEMENT,
  RECTANGLE
 , PROMPT_WIDGET, AI_IMAGE_WIDGET} from 'constants/widgetTypes';

import { Frame } from "scenejs";

import { WidgetRegistry } from 'components/Editor/widgets/registry';
import { EDITOR_SELECT_WIDGET_REQUEST } from 'constants/actionTypes';
import { changeFieldTypeRequest, createAddFieldRequest, moveWidgetsInForm } from 'components/Editor/helper/forms';
import { updateVariableMappings } from './pages';
import { parseHtmlToWidgets } from 'components/Editor/renderer/widgetGenerator';
import { generateHTML, generateImageSnapshot } from 'components/Editor/renderer/generator';
import {
  getYForWidget,
  getAllAncestors,
  applyHeightChangesToAncestors,
  getAutoGrowConfig,
  findContainerWidget,
  getImpactedWidgets,
  getImpactedWidgetChanges,
  getLiveElementParentChanges,
  isLiveElementInsideCarousel,
} from '@paperflite-marketing/cleverstory-commons';
import { toast } from 'react-toastify';
import { WarningToast } from 'components/Toast';
import { hadAutoGrowInWidgetOrDescendants } from 'components/Editor/components/autoGrow';
import { extractWidgetsFromHTML } from 'components/Editor/extractor';
// import { HTMLdummy, SectionBackgroundHTML, SectionBackgroundLayoutConfig, layoutConfig } from './dummy';

import { SEGMENT_STORYBOARDS } from 'constants/storyboardType';


const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const optimizeUrl = process.env.REACT_APP_CLEVERSTORY_SERVICE_URL;
const promptEditorUrl = process.env.REACT_APP_CLEVERSTORY_PYTHON_SERVICE_URL;

const WIDGET_URL = `${apiUrl}/api/1.0/widgets`;
const OPTIMIZE_URL = `${optimizeUrl}/cleverstory/1.0/mobile-optimize`;
const PROMPT_EDITOR_URL = `${optimizeUrl}/cleverstory/prompt-editor/1.0`;
const PYTHON_PROMPT_EDITOR_URL = `${promptEditorUrl}/ai-builder`;

const shortid = require('shortid');
const NEW_SEGMENT = {
  type: PAGE,
  name: 'Frame',
  properties: {
    desktop: {
      autoCreateAlias: false,
      visible: true,
      container: {
        minWidth: 1200
      },
      layout: {
        width: `${1200}px`,
        height: `${600}px`
      }
    },
    mobile: {
      autoCreateAlias: false,
      container: {
        minWidth: 375
      },
      layout: {
        width: `${375}px`,
        height: `${600}px`
      }
    }
  }
}

export const createEditorSession = createAction(EDITOR_CREATE_SESSION, (editorSession, session) => {
  return {
    id: editorSession,
    session: session
  };
});

export const switchBreakpoint = createAction(EDITOR_SWITCH_BREAKPOINT, (editorSession, breakpoint) => {
  return {
    editorSession: editorSession,
    breakpoint: breakpoint
  };
});

export const createWidget = createAction(EDITOR_CREATE_WIDGET, (editorSession, request, parent, selectOnCreation = true, mediaPaste = false) => {
  const processed = generateWidgetsFromPaletteRequest(editorSession, request, parent);
  let collectedMappings = [];

  if (processed && processed.length > 0) {
    processed.forEach(p => {
      if (Array.isArray(p?.variableMappings)) {
        p.variableMappings.forEach(vm => {
          collectedMappings.push(vm);
        });
      }
    });

  }

  return {
    editorSession: editorSession,
    parent: parent,
    widgets: mediaPaste ? request : processed,
    selectOnCreation: selectOnCreation,
    variableMappings: collectedMappings.length > 0 ? collectedMappings : undefined
  };
});


function* handleVariableMappingSaga(action) {
  const { variableMappings, editorSession } = action.payload;

  if (variableMappings && variableMappings.length > 0) {
    const pageId = editorSession.split('_')[1];
    yield put(updateVariableMappings(pageId, variableMappings));
  }
}

export const deleteWidgets = createAction(EDITOR_DELETE_WIDGET, (editorSession, widgets, isContentGrid = false) => {
  return {
    editorSession: editorSession,
    widgets: widgets,
    isContentGrid: isContentGrid
  };
});

function* deleteWidgetsSaga(action) {
  const { editorSession, widgets } = action.payload;

  const deleteWidgets = yield select(state => {
    const pastStates = _.get(state, `${editorSession}.past`) || [];

    const lastState = _.size(pastStates) - 1;
    if (lastState < 0) {
      return [];
    }

    const availbleWidgets = _.get(state, `${editorSession}.past[${lastState}].widgets`) || [];
    const result = availbleWidgets.filter(item => {
      return _.includes(widgets, item.uid);
    });

    return result;
  });

  var impactedSections = deleteWidgets.filter(item => item.type === SECTION_COLUMN).map(item => item.parent);
  impactedSections = _.uniq(impactedSections);

  yield all(impactedSections.map(section => {
    return put(recalculateSectionColumnWidths(editorSession, section));
  }));
}

export const selectWidget = createAction(EDITOR_SELECT_WIDGET_REQUEST, (editorSession, widgets) => {
  return {
    editorSession: editorSession,
    widgets: widgets
  };
});

export const selectPageWidget = createAction(EDITOR_SELECT_PAGE_WIDGET, (editorSession, widget) => {
  return {
    editorSession: editorSession,
    widget: widget
  }
})

export const selectPageSegment = createAction(EDITOR_SELECT_ACTIVE_SEGMENT, (editorSession, activeSegment) => {
  return {
    editorSession: editorSession,
    activeSegment: activeSegment
  }
})

const selectWidgetSuccedded = createAction(EDITOR_SELECT_WIDGET, (editorSession, widgets) => {
  return {
    editorSession: editorSession,
    widgets: widgets
  };
});

export const unselectWidget = createAction(EDITOR_UNSELECT_WIDGET, (editorSession, widgets) => {
  return {
    editorSession: editorSession,
    widgets: widgets
  };
});

export const selectWidgetRange = createAction(EDITOR_SELECT_WIDGET_RANGE, (editorSession, startIndex, endIndex, allWidgets) => {
  return {
    editorSession: editorSession,
    startIndex: startIndex,
    endIndex: endIndex,
    allWidgets: allWidgets
  };
});

function* selectWidgetSaga(action) {
  const { editorSession, widgets } = action.payload;

  const selectedWidgets = yield select(state => {
    var widgetItems = _.get(state, `${editorSession}.present.widgets`) || [];

    if (_.size(widgets) === 0) {
      return [];
    }

    // O(1) lookup map — avoids O(n) .find() per widget in the selection loop
    const widgetMap = new Map(widgetItems.map(w => [w.uid, w]));

    const getSelectableWidget = (id, widgetIds) => {
      if (!id) {
        return id;
      }

      const widget = widgetMap.get(id);
      if (!widget) {
        return id;
      }

      // To Prevent selecting group widgets when selecting the entire group using drag
      const parentId = widgetIds.find(uid => uid === widget.parent);
      const parent = widgetMap.get(parentId);

      if (parent?.type === GROUP) {
        return null;
      }

      const type = widget.type;
      const config = WidgetRegistry.moveableConfig(editorSession, type);

      if (!config) {
        return id;
      }

      const selectable = _.get(config, 'selectable', true);
      if (selectable) {
        return id;
      }

      return getSelectableWidget(widget.parent, widgetIds);
    };

    var selected = widgets.map(id => {
      return getSelectableWidget(id, widgets);
    }).filter(id => id != null);

    selected = _.uniq(selected);

    return selected;
  });

  yield put(selectWidgetSuccedded(editorSession, selectedWidgets));
}


/**
 * Select all Widgets
 * 
*/
export const selectAllWidgets = createAction(EDITOR_SELECT_ALL_WIDGETS, (editorSession, storyboardType, breakpoint) => {
  return {
    editorSession: editorSession,
    storyboardType: storyboardType,
    breakpoint: breakpoint
  };
});

function* selectAllWidgetsSaga(action) {
  const { editorSession, storyboardType, breakpoint } = action.payload;

  const widgets = yield select(state => {
    const parent =
      SEGMENT_STORYBOARDS.includes(storyboardType)
        ? _.get(state, `${editorSession}.present.selectedPage`)
        : _.get(state, `${editorSession}.present.interactive.active`);

    const allWidgets = _.get(state, `${editorSession}.present.widgets`) || [];

    // Filter by parent and visibility
    const visibleWidgets = allWidgets
      .filter(widget => {
        if (widget.parent !== parent) return false;

        const visibility = _.get(widget, `properties.${breakpoint}.visible`, true);
        return visibility !== false; 
      })
      .map(widget => widget.uid);

    return visibleWidgets;
  });

  if (_.isEmpty(widgets)) {
    return;
  }

  yield put(selectWidget(editorSession, widgets));
}


export const toggleEditMode = createAction(EDITOR_TOGGLE_EDIT_MODE, (editorSession, widget, edit, view, batchEdit = false) => {
  return {
    editorSession: editorSession,
    widget: widget,
    edit: edit,
    view: view,
    batchEdit: batchEdit
  };
});

export const updateSpatialSettingMode = createAction(EDITOR_UPDATE_SPATIAL_SETTING_MODE, (editorSession, view) => {
  return {
    editorSession: editorSession,
    view: view
  }
})

export const updateFlipbookSettingMode = createAction(EDITOR_UPDATE_FLIPBOOK_SETTING_MODE, (editorSession, view) => {
  return {
    editorSession: editorSession,
    view: view
  }
})

export const toggleHotspotView = createAction(EDITOR_TOGGLE_HOTSPOT_VIEW, (editorSession, id) => {
  return {
    editorSession: editorSession,
    id: id
  }
})

export const updateWidgetLayout = createAction(EDITOR_UPDATE_WIDGET_LAYOUT, (editorSession, widget, breakpoint, layout) => {
  return {
    editorSession: editorSession,
    widget: widget,
    breakpoint: breakpoint,
    layout: layout
  };
});

function* updateWidgetLayoutSaga(action) {
  const { editorSession, widget, breakpoint, layout } = action.payload;

  const widgetProps = yield select(state => {
    const items = _.get(state, `${editorSession}.present.widgets`) || [];
    return items.find(item => item.uid === widget);
  });

  const config = WidgetRegistry.moveableConfig(editorSession, widgetProps);
  var processedLayout = layout;
  if (config && config.onResize) {
    processedLayout = config.onResize(widgetProps, processedLayout, breakpoint);
  }

  yield put(updateWidgetProperty(editorSession, widget, breakpoint, {
    layout: processedLayout
  }));
}

/**
 * Bulk Update Widget layouts 
*/
function* widgetLayoutChangesIndicatorSaga(action) {
  const { editorSession, widgets,  selectOnCreation} = action.payload;

  const deleteWidgets = yield select(state => {
    const pastStates = _.get(state, `${editorSession}.past`) || [];

    const lastState = _.size(pastStates) - 1;
    if (lastState < 0) {
      return [];
    }

    const availbleWidgets = _.get(state, `${editorSession}.past[${lastState}].widgets`) || [];
    const result = availbleWidgets.filter(item => {
      return _.includes(widgets, item.uid);
    });

    return result;
  });

  if((action.type === 'EDITOR_CREATE_WIDGET' && !selectOnCreation) || (action.type === 'EDITOR_DELETE_WIDGET' && _.size(deleteWidgets) < 1)) {
    return;
  }
}

/**
 * Bulk Update Widget layouts 
*/
export const bulkUpdateWidgetLayouts = createAction(EDITOR_BULK_UPDATE_WIDGET_LAYOUT, (editorSession, breakpoint, layouts) => {
  return {
    editorSession: editorSession,
    breakpoint: breakpoint,
    layouts: layouts
  };
});

function* bulkUpdateWidgetLayoutSaga(action) {
  const { editorSession, breakpoint, layouts } = action.payload;

  const widgets = yield select(state => _.get(state, `${editorSession}.present.widgets`) || []);
  const currentBreakpoint = yield select(state => _.get(state, `${editorSession}.present.breakpoint`));
  var layoutChanges = [];

  const changeRequests = yield select(state => {
    const items = _.get(state, `${editorSession}.present.widgets`) || [];
    const widgets = items.filter(item => {
      return layouts.find(change => change.id === item.uid) != null;
    });

    var changes = {};
    widgets.forEach(widget => {
      const change = layouts.find(change => change.id === widget.uid);
      if (!change) {
        return;
      }

      const config = WidgetRegistry.moveableConfig(editorSession, widget);
      var processedLayout = change.layout;

      if (config && config.onResize) {
        processedLayout = config.onResize(widget, processedLayout, breakpoint);
      }

      changes[widget.uid] = {
        id: widget.uid,
        path: `properties.${breakpoint}.layout`,
        value: processedLayout
      }

      if (layoutChanges.some(item => item.id === widget.uid)) {
        layoutChanges = layoutChanges.map(change => {
          if (change.id === widget.uid) {
            return {
              ...change,
              layout: processedLayout
            }
          }

          return change;
        })
      } else {
        layoutChanges = [...layoutChanges, {
          id: widget.uid,
          layout: processedLayout
        }]
      }

      const template = _.get(widget, 'template.widget') || widget.uid;
      if (template) {
        const templateChanges = items.filter(item => {
          if (item.uid === template) {
            return true;
          } else if (_.get(item, 'template.widget') === template) {
            return true;
          }

          return false;
        });

        if (_.size(templateChanges) > 0) {
          templateChanges.forEach(item => {
            changes[item.uid] = {
              id: item.uid,
              path: `properties.${breakpoint}.layout`,
              value: processedLayout
            }
          })
        }
      }
    });

    return changes;
  });

  var groupChildren = Object.keys(changeRequests).filter(id => {
    return isWidgetInsideGroup(widgets, id)
  });

  groupChildren.forEach(id => {
    var groupWidget = getParentGroupWidget(widgets, id);
    var groupLayoutRequests = processGroupWidgetLayout(groupWidget.uid, breakpoint, widgets, layoutChanges, editorSession);

    groupLayoutRequests.forEach(item => {
      changeRequests[item.id] = item;
    })
  });

  yield put(applyWidgetPropertyChanges(editorSession, changeRequests, currentBreakpoint));
}

export const processGroupWidgetLayout = (id, breakpoint, widgets, layoutChanges, editorSession) => {

  var children = [...widgets].filter(item => item.parent === id);
  var widget = [...widgets].find(item => item.uid === id);

  if (!widget) {
    return [];
  }

  const visibleChildren = children.filter(item =>
    _.get(item, `properties.${breakpoint}.visible`, true)
  );
  if (visibleChildren.length === 0) {
    return [];
  }

  const resolveChildRect = (child) => {
    const childLayout = getLayoutForWidget(child);
    let wRect = getBoundingRectFromLayout(childLayout);

    if (!wRect || wRect.width !== wRect.width || wRect.height !== wRect.height) {
      const boundRect = getWidgetBoundingRectForBreakpoint(editorSession, child, breakpoint);
      if (boundRect) {
        wRect = {
          x: wRect?.x ?? boundRect.x,
          y: wRect?.y ?? boundRect.y,
          width: boundRect.width,
          height: boundRect.height
        };
      }
    }

    return wRect;
  };

  const getLayoutForWidget = (widget) => {
    var layoutChange = layoutChanges.find(item => item.id === widget.uid);
    return layoutChange ? layoutChange.layout : _.get(widget, `properties.${breakpoint}.layout`);
  }

  const calculateRequestForBreakpoint = (editorSession, children, breakpoint) => {
    var left = Number.MAX_SAFE_INTEGER;
    var top = Number.MAX_SAFE_INTEGER;
    var bottom = 0;
    var right = 0;

    children = children.filter(item =>
      _.get(item, `properties.${breakpoint}.visible`, true)
    );

    children.forEach(child => {
      const wRect = resolveChildRect(child);

      if (wRect) {
        left = Math.min(wRect.x, left);
        top = Math.min(wRect.y, top);

        right = Math.max(right, wRect.x + wRect.width);
        bottom = Math.max(bottom, wRect.y + wRect.height);
      }
    });

    const width = Math.ceil(right - left);
    const height = Math.ceil(bottom - top);

    return {
      x: groupWidgetRect.x + left,
      y: groupWidgetRect.y + top,
      width: width,
      height: height,
      minX: left,
      minY: top
    };
  }

  const groupLayout = getLayoutForWidget(widget);
  const groupWidgetRect = getBoundingRectFromLayout(groupLayout);

  if (!groupWidgetRect) {
    return [];
  }

  const request = calculateRequestForBreakpoint(editorSession, children, breakpoint);

  if (
    request.minX === Number.MAX_SAFE_INTEGER ||
    !isFinite(request.width) ||
    !isFinite(request.height) ||
    request.width <= 0 ||
    request.height <= 0
  ) {
    return [];
  }

  var layoutRequests = [{
    id: widget.uid,
    path: `properties.${breakpoint}.layout`,
    value: {
      ...groupLayout,
      transform: {
        ...groupLayout.transform,
        translate: `${request.x}px, ${request.y}px`
      },
      width: `${request.width}px`,
      height: `${request.height}px`,
      minWidth: `${request.width}px`,
      minHeight: `${request.height}px`
    }
  }];

  children.forEach(item => {
    const wRect = resolveChildRect(item);
    if (!wRect) {
      return;
    }

    let childLayout = getLayoutForWidget(item);

    let x = 0;
    if (request.minX < 0) {
      x = wRect.x + Math.abs(request.minX);
    } else {
      x = wRect.x - Math.abs(request.minX);
    }

    let y = wRect.y - request.minY;
    if (request.minY < 0) {
      y = wRect.y - request.minY
    }

    childLayout = {
      ...childLayout,
      transform: {
        ...childLayout.transform,
        translate: `${x}px, ${y}px`
      }
    }

    layoutRequests = [...layoutRequests, {
      id: item.uid,
      path: `properties.${breakpoint}.layout`,
      value: childLayout
    }]
  })

  return layoutRequests;
}

function applyVisibilityChangesToWidgets(widgets, visibilityChanges) {
  if (_.isEmpty(visibilityChanges)) {
    return widgets;
  }

  return widgets.map((widget) => {
    const change = visibilityChanges[widget.uid];
    if (!change || !_.has(change.value, 'visible')) {
      return widget;
    }

    const updated = _.cloneDeep(widget);
    const current = _.get(updated, change.path) || {};
    _.set(updated, change.path, { ...current, ...change.value });
    return updated;
  });
}

export function collectGroupLayoutChangesAfterVisibility(editorSession, widgetIds, breakpoint, widgets, visibilityChanges) {
  const resolvedWidgets = applyVisibilityChangesToWidgets(widgets, visibilityChanges);
  const groupIds = new Set();

  widgetIds.forEach((id) => {
    const group = getParentGroupWidget(resolvedWidgets, id);
    if (group) {
      groupIds.add(group.uid);
    }
  });

  const changes = {};
  groupIds.forEach((groupId) => {
    const requests = processGroupWidgetLayout(groupId, breakpoint, resolvedWidgets, [], editorSession);
    requests.forEach((item) => {
      changes[item.id] = item;
    });
  });

  return changes;
}

export const updateWidgetProperty = createAction(EDITOR_UPDATE_WIDGET_PROPERTY, (editorSession, widget, breakpoint, property) => {
  return {
    editorSession: editorSession,
    widget: widget,
    breakpoint: breakpoint,
    property: property
  };
});

export const updateBulkWidgetProperty = createAction(EDITOR_BULK_UPDATE_WIDGET_PROPERTY, (editorSession, widgetIds, breakpoint, property) => {
  return {
    editorSession: editorSession,
    widgetIds: widgetIds,
    breakpoint: breakpoint,
    property: property
  };
});

export const applyWidgetPropertyChanges = createAction(EDITOR_APPLY_WIDGET_PROPERTY_CHANGES, (editorSession, changes, currentBreakpoint, availableFonts = [], bypassLock = false) => {
  return {
    editorSession: editorSession,
    changes: changes,
    currentBreakpoint: currentBreakpoint,
    availableFonts: availableFonts,
    bypassLock: bypassLock
  };
});

export const applyBulkWidgetPropertyChanges = createAction(EDITOR_APPLY_BULK_WIDGET_PROPERTY_CHANGES, (editorSession, changes, currentBreakpoint) => {
  return {
    editorSession: editorSession,
    changes: changes,
    currentBreakpoint: currentBreakpoint
  };
});

function* updateWidgetPropertySaga(action) {
  const { editorSession, widget, breakpoint, property } = action.payload;

  const widgetProps = yield select(state => {
    const items = _.get(state, `${editorSession}.present.widgets`) || [];
    return items.find(item => item.uid === widget);
  });

  const currentBreakpoint = yield select(state => _.get(state, `${editorSession}.present.breakpoint`));

  if (!widgetProps) {
    return;
  }

  var changes = {};
  changes[widgetProps.uid] = {
    id: widgetProps.uid,
    path: `properties.${breakpoint}`,
    value: property
  }

  const template = _.get(widgetProps, 'template.widget') || widgetProps.uid;
  if (template) {
    const templateChanges = yield select(state => {
      const items = _.get(state, `${editorSession}.present.widgets`) || [];
      return items.filter(item => {
        if (item.uid === template) {
          return true;
        } else if (_.get(item, 'template.widget') === template) {
          return true;
        }

        return false;
      }).map(item => {
        return {
          uid: item.uid,
          property: property
        }
      });
    });

    if (_.size(templateChanges) > 0) {
      templateChanges.forEach(item => {
        changes[item.uid] = {
          id: item.uid,
          path: `properties.${breakpoint}`,
          value: property
        }
      })
    }
  }

  if (_.has(property, 'visible')) {
    actionGroup.start();

    yield put(applyWidgetPropertyChanges(editorSession, changes, currentBreakpoint));

    if (property.visible === true) {
      yield delay(50);
    }

    const widgets = yield select(
      (state) => _.get(state, `${editorSession}.present.widgets`) || []
    );
    const affectedIds = Object.keys(changes);
    const groupChanges = collectGroupLayoutChangesAfterVisibility(
      editorSession,
      affectedIds,
      breakpoint,
      widgets,
      changes
    );

    if (!_.isEmpty(groupChanges)) {
      yield put(applyWidgetPropertyChanges(editorSession, groupChanges, currentBreakpoint));
    }

    actionGroup.end();
  } else {
    yield put(applyWidgetPropertyChanges(editorSession, changes, currentBreakpoint));
  }
}

function* updateBulkWidgetsPropertySaga(action) {
  const { editorSession, widgetIds, breakpoint, property } = action.payload;

  const widgets = yield select((state) => {
    const allWidgets = _.get(state, `${editorSession}.present.widgets`) || [];
    return allWidgets.filter((w) => widgetIds.includes(w.uid));
  });

  const currentBreakpoint = yield select((state) =>
    _.get(state, `${editorSession}.present.breakpoint`)
  );

  if (_.isEmpty(widgets)) return;

  const changes = {};

  for (let i = 0; i < widgets.length; i++) {
    const widget = widgets[i];

    const value = Array.isArray(property)
      ? property[i]
      : property?.[widget.uid] ?? property;

    changes[widget.uid] = {
      id: widget.uid,
      path: `properties.${breakpoint}`,
      value,
    };

    const template = _.get(widget, 'template.widget') || widget.uid;

    if (template) {
      const templateChanges = yield select((state) => {
        const all = _.get(state, `${editorSession}.present.widgets`) || [];
        return all.filter(
          (item) =>
            item.uid === template ||
            _.get(item, 'template.widget') === template
        );
      });

      templateChanges.forEach((item, index) => {
        const templateValue = Array.isArray(property)
          ? property[i]                  // same index as parent widget
          : property?.[item.uid] ?? property;

        changes[item.uid] = {
          id: item.uid,
          path: `properties.${breakpoint}`,
          value: templateValue,
        };
      });
    }
  }

  const hasVisibilityChange = Object.values(changes).some(
    (c) => c.value != null && _.has(c.value, 'visible')
  );

  if (hasVisibilityChange) {
    actionGroup.start();
  }

  yield put(
    applyBulkWidgetPropertyChanges(
      editorSession,
      changes,
      currentBreakpoint
    )
  );

  if (hasVisibilityChange) {
    const isUnhide = Object.values(changes).some(
      (c) => c.value != null && c.value.visible === true
    );
    if (isUnhide) {
      yield delay(50);
    }

    const allWidgets = yield select(
      (state) => _.get(state, `${editorSession}.present.widgets`) || []
    );
    const affectedIds = Object.keys(changes);
    const groupChanges = collectGroupLayoutChangesAfterVisibility(
      editorSession,
      affectedIds,
      breakpoint,
      allWidgets,
      changes
    );

    if (!_.isEmpty(groupChanges)) {
      yield put(applyWidgetPropertyChanges(editorSession, groupChanges, currentBreakpoint));
    }

    actionGroup.end();
  }
}

export const updateWidgetTemplateProperty = createAction(EDITOR_UPDATE_WIDGET_TEMPLATE_PROPERTY, (editorSession, widget, breakpoint, property) => {
  return {
    editorSession: editorSession,
    widget: widget,
    breakpoint: breakpoint,
    property: property
  };
});

export const updateWidgetActions = createAction(EDITOR_UPDATE_WIDGET_ACTIONS, (editorSession, widget, actions) => {
  return {
    editorSession: editorSession,
    widget: widget,
    actions: actions
  };
});

function* updateWidgetActionsSaga(action) {
  const { editorSession, widget, actions } = action.payload;

  const widgetProps = yield select(state => {
    const items = _.get(state, `${editorSession}.present.widgets`) || [];
    return items.find(item => item.uid === widget);
  });

  const currentBreakpoint = yield select(state => _.get(state, `${editorSession}.present.breakpoint`));

  if (!widgetProps) {
    return;
  }

  var changes = {};
  changes[widgetProps.uid] = {
    id: widgetProps.uid,
    path: `actions`,
    value: actions
  }

  const template = _.get(widgetProps, 'template.widget') || widgetProps.uid;
  if (template) {
    const templateChanges = yield select(state => {
      const items = _.get(state, `${editorSession}.present.widgets`) || [];
      return items.filter(item => {
        if (item.uid === template) {
          return true;
        } else if (_.get(item, 'template.widget') === template) {
          return true;
        }

        return false;
      }).map(item => {
        return {
          uid: item.uid,
          actions: actions
        }
      });
    });

    if (_.size(templateChanges) > 0) {
      templateChanges.forEach(item => {
        changes[item.uid] = {
          id: item.uid,
          path: `actions`,
          value: actions
        }
      })
    }
  }

  yield put(applyWidgetPropertyChanges(editorSession, changes, currentBreakpoint));
}


export const updatePageSettings = createAction(EDITOR_UPDATE_PAGE_SETTINGS, (editorSession, widget, uid, breakpoint, property) => {
  return {
    editorSession: editorSession,
    widget: widget,
    uid: uid,
    breakpoint: breakpoint,
    property: property
  };
})

export const updateWidgetContent = createAction(EDITOR_UPDATE_WIDGET_CONTENT, (editorSession, widget, content) => {
  return {
    editorSession: editorSession,
    widget: widget,
    content: content
  };
});

export const updateEditorThemes = createAction(EDITOR_UPDATE_THEMES, (editorSession, format, theme) => {
  return {
    editorSession: editorSession,
    format: format,
    theme: theme
  }
});

export const updateEditorAppearance = createAction(EDITOR_UPDATE_APPEARANCE, (editorSession, appearance) => {
  return {
    editorSession: editorSession,
    appearance: appearance
  }
})

export const updateEditorBrandColor = createAction(EDITOR_UPDATE_BRAND_COLORS, (editorSession, colors) => {
  return {
    editorSession: editorSession,
    colors: colors
  }
})

export const updateToolsSettings = createAction(EDITOR_UPDATE_TOOLS_SETTINGS, (editorSession, settings) => {
  return {
    editorSession: editorSession,
    settings: settings
  }
})

export const updateWidgetName = createAction(EDITOR_UPDATE_WIDGET_NAME, (editorSession, widget, name) => {
  return {
    editorSession: editorSession,
    widget: widget,
    name: name
  }
});


function* updateWidgetNameSaga(action) {
  const { editorSession, widget, name } = action.payload;

  const changeRequests = yield select(state => {
    const items = _.get(state, `${editorSession}.present.widgets`) || [];
    const widgetItem = items.find(item => {
      return item.uid === widget;
    });

    if (!widgetItem) {
      return;
    }

    var changes = {};
    changes[widgetItem.uid] = {
      id: widgetItem.uid,
      path: `name`,
      value: name
    }

    const template = _.get(widgetItem, 'template.widget') || widget.uid;
    if (template) {
      const templateChanges = items.filter(item => {
        if (item.uid === template) {
          return true;
        } else if (_.get(item, 'template.widget') === template) {
          return true;
        }

        return false;
      });

      if (_.size(templateChanges) > 0) {
        templateChanges.forEach(item => {
          changes[item.uid] = {
            id: item.uid,
            path: `name`,
            value: name
          }
        })
      }
    }

    return changes;
  });


  if (!changeRequests) {
    return;
  }

  yield put(applyWidgetPropertyChanges(editorSession, changeRequests));
}


export const bulkUpdateWidgetOrder = createAction(EDITOR_BULK_UPDATE_WIDGET_ORDER, (editorSession, request) => {
  return {
    editorSession: editorSession,
    request: request
  }
});


function* bulkUpdateWidgetOrderSaga(action) {
  const { editorSession, request } = action.payload;

  const changeRequests = yield select(state => {
    const items = _.get(state, `${editorSession}.present.widgets`) || [];
    const widgets = items.filter(item => {
      return request.find(change => change.uid === item.uid) != null;
    });

    var changes = {};
    widgets.forEach(widget => {
      const change = request.find(change => change.uid === widget.uid);
      if (!change) {
        return;
      }

      changes[widget.uid] = {
        id: widget.uid,
        path: `order`,
        value: change.order
      }

      const template = _.get(widget, 'template.widget') || widget.uid;
      if (template) {
        const templateChanges = items.filter(item => {
          if (item.uid === template) {
            return true;
          } else if (_.get(item, 'template.widget') === template) {
            return true;
          }

          return false;
        });

        if (_.size(templateChanges) > 0) {
          templateChanges.forEach(item => {
            changes[item.uid] = {
              id: item.uid,
              path: `order`,
              value: change.order
            }
          })
        }
      }
    });

    return changes;
  });

  if (!changeRequests) {
    return;
  }

  yield put(applyWidgetPropertyChanges(editorSession, changeRequests));
}

export const attachWidgetToContainer = createAction(EDITOR_ATTACH_TO_CONTAINER, (editorSession, container, widget, layout) => {
  return {
    editorSession: editorSession,
    container: container,
    widget: widget,
    layout: layout
  };
});

export const bulkAttachWidgetsToContainer = createAction(EDITOR_BULK_ATTACH_TO_CONTAINER, (editorSession, container, widgets, layouts) => {
  return {
    editorSession: editorSession,
    container: container,
    widgets: widgets,
    layouts: layouts
  };
});


function* showAutoGrowDisabledToastSaga(action) {
  const { editorSession, widget: widgetId, container: containerId } = action.payload;
  const state = yield select();
  const editorState = _.get(state, editorSession);
  const past = _.get(editorState, 'past', []);
  const previousPresent = past[past.length - 1];
  const previousWidgets = _.get(previousPresent, 'widgets', []) || [];
  const hadAutoGrowEnabled = hadAutoGrowInWidgetOrDescendants(previousWidgets, widgetId);

  if (!hadAutoGrowEnabled) return;

  const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
  const containerWidget = widgets.find(w => w.uid === containerId);
  if (containerWidget?.type === CAROUSEL_CARD) {
    toast(
      <WarningToast
        description="Auto Grow isn't available for HTML widgets inside a carousel. We've disabled it to prevent layout issues."
      />,
      {
        type: toast.TYPE.DEFAULT,
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
      }
    );
  }
}

export const undo = (editorSession) => {
  return createAction(`UNDO_${editorSession}`)();
}

export const redo = (editorSession) => {
  return createAction(`REDO_${editorSession}`)();
}

export const updateGuidelines = createAction(EDITOR_UPDATE_GUIDELINES, (editorSession, direction, breakpoint, guides) => {
  return {
    editorSession: editorSession,
    direction: direction,
    breakpoint: breakpoint,
    guides: guides
  };
});

export const recalculateLayout = createAction(EDITOR_RECALCULATE_LAYOUT, (editorSession, parent) => {
  return {
    editorSession: editorSession,
    parent: parent
  };
});

export const applyLayoutChanges = createAction(EDITOR_APPLY_LAYOUT_CHANGES, (editorSession, breakpoint, changes) => {
  return {
    editorSession: editorSession,
    breakpoint: breakpoint,
    changes: changes
  };
});

function* recalculateLayoutSaga(action) {
  const { editorSession, parent } = action.payload;

  const allWidgets = yield select(state => _.get(state, `${editorSession}.present.widgets`) || []);
  const parentArray = Array.isArray(parent) ? parent : [parent];

    // loop through each parent
    for (const parentId of parentArray) {
      const widget = allWidgets.find(w => w.uid === parentId);
  
      // filter widgets per parent
      let widgets = allWidgets.filter(item => {
        let visibleCheck = document.getElementById(item.uid)?.getAttribute("data-selectable");
        let parentCheck = document.getElementById(item.parent)?.getAttribute("data-widget-type");
  
        if (!visibleCheck && (parentCheck === CAROUSEL_CARD || parentCheck === CAROUSEL)) {
          return false;
        }
  
        if (!_.get(item, 'properties.mobile.visible')) {
          return false;
        }
  
        return true;
      });
  
      if (_.isEmpty(widgets)) {
        continue;
      }
  
      const context = {
        editorSession,
        breakpoint: "mobile",
        widgets
      };
  
      actionGroup.start();
  
      const changeRequests = recalculateLayoutForBreakpoint(context, widget);
      yield put(applyLayoutChanges(editorSession, "mobile", changeRequests));
  
      actionGroup.end();
    }
}


/*
* Interactive actions
*/
export const createInteractivePageSection = createAction(EDITOR_INTERACTIVE_CONTENT_CREATE_PAGE, (editorSession, index) => {
  return {
    editorSession: editorSession,
    index: index
  };
});

function* createInteractivePageSectionSaga(action) {
  const { editorSession, index } = action.payload;

  const request = {
    type: PAGE,
    name: 'Untitled Page',
    order: index,
    properties: {
      desktop: {
        autoCreateAlias: true,
        container: {
          minWidth: 1200
        },
        layout: {
          width: `${1200}px`,
          height: `${600}px`
        },
        visible: true
      },
      mobile: {
        autoCreateAlias: true,
        container: {
          minWidth: 375
        },
        layout: {
          width: `${375}px`,
          height: `${600}px`
        }
      }
    }
  }

  yield put(createWidget(editorSession, [request], null));

  const pageAdded = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    const pages = widgets.filter(page => {
      return page.type === PAGE;
    });

    const index = _.size(pages) - 1;
    return pages[index];
  });

  if (pageAdded) {
    yield put(switchInteractivePageSection(editorSession, pageAdded.uid));
  }
}

export const switchInteractivePageSection = createAction(EDITOR_INTERACTIVE_CONTENT_SWITCH_PAGE, (editorSession, section) => {
  return {
    editorSession: editorSession,
    section: section
  };
});

export const copyWidgets = createAction(EDITOR_COPY_WIDGETS, (editorSession, editorState) => {
  return {
    editorSession: editorSession,
    editorState: editorState,
    remove: false
  };
});

export const cutWidgets = createAction(EDITOR_CUT_WIDGETS, (editorSession, editorState) => {
  return {
    editorSession: editorSession,
    editorState: editorState,
    remove: true
  };
});

function* copyWidgetsSaga(action) {
  const { editorSession, editorState, remove } = action.payload;
  const pageId = editorSession.split("_")[1];
  const page = yield select((state) =>
      _.get(state, `pages.page.${pageId}.item`, [])
    );
  const variableMappings = _.get(page, "variableMappings", []);
  
  const _cleanData = (widget) => {
    const children = widget.widgets;
    if (_.size(children) > 0) {
      widget.widgets = children.map(child => _cleanData(child));
    }
    
    if (widget.properties && widget.properties.mobile) {
      widget.properties.mobile.disableOptimize = false;
    }

    return _.omit(widget, ['id', 'uid', 'parent', 'template']);
  }

  const widgets = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);

    const _findWidget = (id) => {
      return widgets.find(widget => widget.uid === id);
    }

    const _findChildren = (parent) => {
      return widgets.filter(widget => widget.parent === parent);
    }

    const reCalculateWidgetLayout = (widget, layout, breakpoint) => {
      var wRect = getBoundingRectFromLayout(layout);

      var parent = _findWidget(widget.parent);
      var pLayout = _.get(parent, `properties.${breakpoint}.layout`)
      var pRect = getBoundingRectFromLayout(pLayout);

      const frame = new Frame(layout);
      var x = wRect.x + pRect.x;
      var y = wRect.y + pRect.y;

      const translate = `${x}px, ${y}px`;

      frame.set("transform", "translate", translate);
      var updatedLayout = frame.get();

      if (parent && !_.includes([PAGE, MODAL, SLIDE, LIVE_ELEMENT_CONTAINER], parent.type)) {
        return reCalculateWidgetLayout(parent, updatedLayout, breakpoint);
      }

      return updatedLayout;
    }

    const _buildCopyRequest = (widget, calculateLayout) => {
      var widgetRequest = _.cloneDeep(widget);
      var children = _findChildren(widget.uid);
      var parent = _findWidget(widget.parent);
      const widgetVariables = variableMappings.filter(vm => vm.widget === widget.uid);
      if (widgetVariables.length > 0) {
        widgetRequest.variableMappings = widgetVariables;
      }

      if (!_.includes([PAGE, LIVE_ELEMENT_CONTAINER, SLIDE], parent.type) && calculateLayout) {
        let desktopLayout = reCalculateWidgetLayout(widget, _.get(widget, `properties.desktop.layout`), 'desktop');

        let mobileLayout = reCalculateWidgetLayout(widget, _.get(widget, `properties.mobile.layout`), 'mobile');

        widgetRequest = {
          ...widgetRequest,
          properties: {
            ...widgetRequest.properties,
            desktop: {
              ...widgetRequest.properties.desktop,
              layout: desktopLayout
            },
            mobile: {
              ...widgetRequest.properties.mobile,
              layout: mobileLayout
            }
          }
        }
      }

      if (_.size(children) > 0) {
        widgetRequest.widgets = children
          .map(child => _buildCopyRequest(child, false))
          .sort((w1, w2) => {
            const o1 = _.get(w1, 'order') || 1;
            const o2 = _.get(w2, 'order') || 1;

            return o1 - o2;
          });
      }

      return widgetRequest;
    }

    const selected = _.get(state, `${editorSession}.present.selected`, []).filter(w => {
      var type = getWidgetType(editorSession, w);
      return ![SECTION_COLUMN, HOTSPOT].includes(type)
    });

    if (_.size(selected) == 0) {
      return [];
    }

    var processedWidgets = selected.map(id => _findWidget(id))
      .filter(widget => {
        const moveableConfig = WidgetRegistry.moveableConfig(editorSession, widget);
        return _.get(moveableConfig, 'cloneable', true);
      })
      .map(widget => _buildCopyRequest(widget, true));

    return processedWidgets;
  });

  if (_.size(widgets) == 0) {
    return;
  }

  var request = {
    ...editorState,
    widgets: widgets.map(widget => _cleanData(widget))
  }

  window.localStorage.setItem('CLIPBOARD', JSON.stringify(request));

  if (remove) {
    const widgetsToDelete = widgets.map(widget => widget.uid);
    yield put(deleteWidgets(editorSession, widgetsToDelete));
  }
}

export const cloneWidgets = createAction(EDITOR_CLONE_WIDGETS, (editorSession, parent, widgets) => {
  return {
    editorSession: editorSession,
    parent: parent,
    selectedWidgets: widgets
  };
});

function* cloneWidgetsSaga(action) {
  const { editorSession, selectedWidgets, parent } = action.payload;
  const pageId = editorSession.split("_")[1];
  const page = yield select((state) =>
      _.get(state, `pages.page.${pageId}.item`, [])
    );
  const variableMappings = _.get(page, "variableMappings", []);

  const _cleanData = (widget) => {
    const children = widget.widgets;
    if (_.size(children) > 0) {
      widget.widgets = children.map(child => _cleanData(child));
    }

    if (widget.properties && widget.properties.mobile) {
      widget.properties.mobile.disableOptimize = false;
    }

    return _.omit(widget, ['id', 'uid', 'parent', 'template']);
  }

  const parentWidgetType = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);
    const parentWidget = widgets.find(widget => widget.uid === parent);
    return _.get(parentWidget, 'type');
  })

  const clonedWidgets = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);

    const _findWidget = (id) => {
      return widgets.find(widget => widget.uid === id);
    }

    const _findChildren = (parent) => {
      return widgets.filter(widget => widget.parent === parent);
    }

    const _buildCopyRequest = (widget) => {
      const widgetRequest = _.cloneDeep(widget);
      var children = _findChildren(widget.uid);
      const widgetVariables = variableMappings.filter(vm => vm.widget === widget.uid);
      if (widgetVariables.length > 0) {
        widgetRequest.variableMappings = widgetVariables;
      }

      if (_.size(children) > 0) {
        widgetRequest.widgets = children
          .map(child => _buildCopyRequest(child))
          .sort((w1, w2) => {
            const o1 = _.get(w1, 'order') || 1;
            const o2 = _.get(w2, 'order') || 1;

            return o1 - o2;
          });
      }

      return widgetRequest;
    }

    if (_.size(selectedWidgets) == 0) {
      return [];
    }

    var processedWidgets = selectedWidgets.map(id => _findWidget(id))
      .filter(widget => {
        const moveableConfig = WidgetRegistry.moveableConfig(editorSession, widget);
        return _.get(moveableConfig, 'cloneable', true);
      })
      .map(widget => _buildCopyRequest(widget))
      .filter(widget => widget != null)
      .map(widget => {
        var cloned = _.cloneDeep(widget);
        cloned = _cleanData(cloned);

        if(widget.type === CONTENT){
          cloned.content = {};
          cloned.properties.desktop.filters = false;
          cloned.properties.desktop.search = false;
          cloned.properties.mobile.filters = false;
          cloned.properties.mobile.search = false;
  
          var contentWidgets = cloned.widgets.filter(item => !_.includes([CONTENT_CARD], item.type));

          contentWidgets.map(child => {
            if([CONTENT_FILTER].includes(child.type)){
                var filterChildren = child.widgets.map(filterChild => {
                  if(filterChild.type === CONTENT_FILTER_CONTAINER){
                    filterChild.content = [];
                  }
                  if(filterChild.type === CONTENT_SEARCH){
                    filterChild.content = null
                  }
                  return filterChild;
                });
                child.widgets = filterChildren;
              }
            })
  
          cloned.widgets = contentWidgets;
        }

        isAssetIsChild(widget, cloned);

        var layout = _.get(cloned, 'properties.desktop.layout') || {};
        const position = new Frame(layout);
        if (position.has("transform", "translate")) {
          const value = position.get("transform", "translate").split(",").map(str => {
            str = str.trim();
            return parseFloat(str);
          });

          let x = value[0] + 20;
          let y = value[1] + 20;
          if (widget.type === SECTION) { x = value[0] }
          position.set('transform', 'translate', `${x}px, ${y}px`);
        }

        var clonedLayout = position.get();

        const moveableConfig = WidgetRegistry.moveableConfig(editorSession, widget);
        if (moveableConfig && moveableConfig.onResize) {
          clonedLayout = moveableConfig.onResize(widget, clonedLayout, 'desktop');
        }

        cloned = _.set(cloned, 'properties.desktop.layout', clonedLayout);
        return cloned;
      });

    return processedWidgets;
  });

  if (_.size(clonedWidgets) == 0) {
    return;
  }

  let selectOnCreation = true;
  if (parentWidgetType == CAROUSEL) {
    selectOnCreation = false;
  }

  yield put(createWidget(editorSession, clonedWidgets, parent, selectOnCreation));
}

export const clonePage = createAction(EDITOR_CLONE_PAGE, (editorSession, page, cloneType) => {
  return {
    editorSession: editorSession,
    page: page,
    cloneType
  }
})

const widgetTypesWithAsset = new Set([SECTION, CAROUSEL, IMAGE, VIDEO, BUTTON, SHAPE, LINE]);
const assetDirectChild = new Set([SECTION_COLUMN, CAROUSEL_CARD, CONTAINER]);

function clearContentInChildren(widget) {
  if (!widget || !widget.widgets) return;

  widget.widgets.forEach(child => {
    if (child?.type === ASSET) {
      child.content = null;
    } else if (child?.widgets) {
      child.widgets.forEach(subChild => {
        if (subChild?.type === CAROUSEL_CARD) {
          subChild.widgets?.forEach(carouselChild => {
            if (carouselChild?.type === ASSET) {
              carouselChild.content = null;
            }
          });
        }
      });
    }
  });
}

function isAssetIsChild(widget, cloned) {
  if (widgetTypesWithAsset.has(widget?.type)) {
    cloned.widgets?.forEach(child => {
      clearContentInChildren(child);
    });
  } else if (assetDirectChild.has(widget?.type)) {
    clearContentInChildren(cloned);
  }
}

export const createPageSegment = createAction(EDITOR_CREATE_SEGMENT, (editorSession, page, position) => {
  return {
    editorSession: editorSession,
    page: page,
    position: position
  };
});

function* createPageSegmentSaga(action) {
  const { editorSession, page, position } = action.payload;

  const newSegment = {
    ...NEW_SEGMENT,
    uid: `widget_${shortid.generate()}`
  };

  const newIndex = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);

    var pageWidgets = widgets.filter(item => item.type === PAGE);
    pageWidgets = _.orderBy(pageWidgets, 'order', 'desc');

    let oldIndex = pageWidgets.findIndex(item => item.uid === page);

    return position === 'top' ? oldIndex : (oldIndex + 1);
  });

  yield put(createWidget(editorSession, [newSegment], null));

  yield put(arrangeWidget(editorSession, newSegment, newIndex));

  const pageAdded = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    let pages = widgets.filter(page => {
      return page.type === PAGE;
    });

    pages = _.orderBy(pages, 'order', 'desc');
    return pages[newIndex];
  });

  if (pageAdded) {
    yield put(selectPageWidget(editorSession, newSegment.uid));
  }
}

export const splitPageBySelection = createAction(EDITOR_SPLIT_PAGE_BY_SELECTION, (editorSession, pageId, selectedIds) => {
  return {
    editorSession,
    pageId,
    selectedIds
  };
});

function isAncestorOf(widgets, ancestorUid, uid) {
  let w = widgets.find(item => item.uid === uid);
  while (w && w.parent) {
    if (w.parent === ancestorUid) return true;
    w = widgets.find(item => item.uid === w.parent);
  }
  return false;
}

function getMobileLayoutY(widget) {
  const t = _.get(widget, 'properties.mobile.layout.transform.translate');
  if (!t) return 0;
  const parts = t.split(',').map(s => s.trim());
  const y = parseInt(parts[1], 10);
  return isNaN(y) ? 0 : y;
}

function getDesktopLayoutY(widget) {
  const t = _.get(widget, 'properties.desktop.layout.transform.translate');
  if (!t) return 0;
  const parts = t.split(',').map(s => s.trim());
  const y = parseInt(parts[1], 10);
  return isNaN(y) ? 0 : y;
}

/** Get absolute Y position of widget within page (sum of layout Y from widget up to page). Preserves exact spacing. */
function getAbsoluteLayoutYInPage(widget, pageId, widgets, breakpoint = 'desktop') {
  let y = 0;
  let current = widget;
  while (current && current.parent && current.parent !== pageId) {
    const layoutY = breakpoint === 'desktop'
      ? getDesktopLayoutY(current)
      : getMobileLayoutY(current);
    y += layoutY;
    current = widgets.find(w => w.uid === current.parent);
  }
  if (current && current.parent === pageId) {
    const layoutY = breakpoint === 'desktop'
      ? getDesktopLayoutY(current)
      : getMobileLayoutY(current);
    y += layoutY;
  }
  return y;
}

function isWidgetHidden(widget) {
  return _.get(widget, 'properties.desktop.visible', true) === false;
}

const CONTAINER_WIDGET_TYPES = new Set([CAROUSEL, SECTION, CONTAINER, GROUP, ASSET, CONTENT, HOTSPOT, MENU, BUTTON, IMAGE, SHAPE, LINE, RECTANGLE]);

function isDescendantOfContainerWidget(widgets, widget, pageId) {
  let current = widgets.find(w => w.uid === widget.parent);
  while (current && current.uid !== pageId) {
    if (CONTAINER_WIDGET_TYPES.has(current.type)) return true;
    current = widgets.find(w => w.uid === current.parent);
  }
  return false;
}

function* splitPageBySelectionSaga(action) {
  const { editorSession, pageId, selectedIds } = action.payload;
  if (!selectedIds || selectedIds.length === 0) return;

  const widgets = yield select(state => _.get(state, `${editorSession}.present.widgets`) || []);
  const pageWidget = widgets.find(w => w.uid === pageId);
  if (!pageWidget || pageWidget.type !== PAGE) return;

  const descendantUids = getWidgetsWithAncestor(widgets, pageId);
  const descendants = descendantUids.map(uid => widgets.find(w => w.uid === uid)).filter(Boolean);
  const selectedSet = new Set(selectedIds);

  let selTop = Infinity;
  let selBottom = -Infinity;
  const spanByUid = {};
  for (const uid of selectedIds) {
    const widget = widgets.find(w => w.uid === uid);
    if (!widget) return;
    const span = getWidgetVerticalSpanInPage(editorSession, pageId, widget);
    if (!span) return;
    spanByUid[uid] = span;
    selTop = Math.min(selTop, span.top);
    selBottom = Math.max(selBottom, span.bottom);
  }
  for (const w of descendants) {
    if (spanByUid[w.uid]) continue;
    const span = getWidgetVerticalSpanInPage(editorSession, pageId, w);
    if (span) spanByUid[w.uid] = span;
  }

  const above = descendants.filter(w => !selectedSet.has(w.uid) && !isWidgetHidden(w) && spanByUid[w.uid] && spanByUid[w.uid].bottom <= selTop && !isDescendantOfContainerWidget(widgets, w, pageId));
  const below = descendants.filter(w => !selectedSet.has(w.uid) && !isWidgetHidden(w) && spanByUid[w.uid] && spanByUid[w.uid].top >= selBottom && !isDescendantOfContainerWidget(widgets, w, pageId));
  const hiddenWidgetsToKeep = descendants.filter(w => !selectedSet.has(w.uid) && isWidgetHidden(w) && !isDescendantOfContainerWidget(widgets, w, pageId));
  const shouldKeepPage = above.length > 0 || hiddenWidgetsToKeep.length > 0;
  const selectionRoots = selectedIds.filter(id => !selectedIds.some(otherId => otherId !== id && isAncestorOf(widgets, otherId, id)));
  const belowRoots = below.filter(w => w.parent === pageId || !below.find(b => b.uid === w.parent));

  const minMobileYSelected = selectionRoots.length > 0
    ? Math.min(...selectionRoots.map(uid => getMobileLayoutY(widgets.find(w => w.uid === uid) || {})))
    : 0;
  const belowMinYMobile = belowRoots.length > 0
    ? Math.min(...belowRoots.map(w => getMobileLayoutY(w)))
    : 0;

  const pageName = _.get(pageWidget, 'name') || 'Frame';
  const pageHeightDesktop = parseInt(_.get(pageWidget, 'properties.desktop.layout.height'), 10) || 600;
  const pageHeightMobile = parseInt(_.get(pageWidget, 'properties.mobile.layout.height'), 10) || 600;
  const selectionHeight = above?.length ? Math.max(50, selBottom - selTop) : Math.max(50, selBottom);
  const belowHeight = belowRoots.length > 0 ? Math.max(50, pageHeightDesktop - selBottom) : 0;

  const pageBackground = _.get(pageWidget, 'properties.desktop.background');
  const pageBackgroundMobile = _.get(pageWidget, 'properties.mobile.background');

  const newSelectionPageProps = {
    type: PAGE,
    name: pageName,
    properties: {
      desktop: {
        autoCreateAlias: false,
        visible: true,
        container: { minWidth: 1200 },
        layout: { width: `${1200}px`, height: `${selectionHeight}px` },
        ...(pageBackground && { background: pageBackground })
      },
      mobile: {
        autoCreateAlias: false,
        container: { minWidth: 375 },
        layout: { width: `${375}px`, height: `${selectionHeight}px` },
        ...(pageBackgroundMobile && { background: pageBackgroundMobile })
      }
    }
  };

  const newBelowPageProps = {
    type: PAGE,
    name: pageName,
    properties: {
      desktop: {
        autoCreateAlias: false,
        visible: true,
        container: { minWidth: 1200 },
        layout: { width: `${1200}px`, height: `${belowHeight}px` },
        ...(pageBackground && { background: pageBackground })
      },
      mobile: {
        autoCreateAlias: false,
        container: { minWidth: 375 },
        layout: { width: `${375}px`, height: `${belowHeight}px` },
        ...(pageBackgroundMobile && { background: pageBackgroundMobile })
      }
    }
  };

  const selectionPageUid = `widget_${shortid.generate()}`;
  const selectionPage = { ...newSelectionPageProps, uid: selectionPageUid };
  let belowPageUid = null;
  let belowPage = null;
  if (belowRoots.length > 0) {
    belowPageUid = `widget_${shortid.generate()}`;
    belowPage = { ...newBelowPageProps, uid: belowPageUid };
  }

  const pageWidgets = widgets.filter(item => item.type === PAGE && !item.parent);
  const orderedPages = _.orderBy(pageWidgets, 'order', 'desc');
  const currentPageIndex = orderedPages.findIndex(p => p.uid === pageId);
  if (currentPageIndex === -1) return;

  actionGroup.start();

  if(!belowPage) {
    selectionPage.properties.desktop.layout.height = above?.length ? `${pageHeightDesktop - selTop}px` : `${pageHeightDesktop}px`;
    selectionPage.properties.mobile.layout.height = above?.length ? `${pageHeightMobile - selTop}px` : `${pageHeightMobile}px`;
  }

  yield put(createWidget(editorSession, [selectionPage], null));

  if (belowPage) {
    yield put(createWidget(editorSession, [belowPage], null));
  }

  if (shouldKeepPage) {
    const aboveHeight = Math.max(50, selTop);

    yield put(updateWidgetProperty(editorSession, pageId, 'desktop', {
      layout: { ..._.get(pageWidget, 'properties.desktop.layout'), height: `${aboveHeight}px` }
    }));

    yield put(updateWidgetProperty(editorSession, pageId, 'mobile', {
      layout: { ..._.get(pageWidget, 'properties.mobile.layout'), height: `${aboveHeight}px` }
    }));
  }

  const widgetIds = [];
  const attachContainerLayouts = [];
  const propertyLayouts = [];

  for (const uid of selectionRoots) {
    const widget = widgets.find(w => w.uid === uid);
    if (!widget) continue;
  
    const span = spanByUid[uid];
    if (!span) continue;
  
    // FIX: Calculate position relative to the new frame's top (selTop)
    const newY = !shouldKeepPage ? span.top : span.top - selTop;  // <- This is the key change!
  
    const layoutDesktop = _.get(widget, 'properties.desktop.layout') || {};
    const translateDesktop =
      (layoutDesktop.transform && layoutDesktop.transform.translate) || '0px, 0px';
    const parts = translateDesktop.split(',').map(s => s.trim());
    const xDesktop = parts[0] || '0px';
    const layoutMobile = _.get(widget, 'properties.mobile.layout') || {};
    const translateMobile =
      (layoutMobile.transform && layoutMobile.transform.translate) || '0px, 0px';
    const partsM = translateMobile.split(',').map(s => s.trim());
    const xMobile = partsM[0] || '0px';
    const layoutForAttach = {
      transform: {
        translate: `${xDesktop}, ${newY}px`,  // Now uses corrected newY
        rotate: _.get(layoutDesktop, 'transform.rotate', '0deg'),
        scale: _.get(layoutDesktop, 'transform.scale', '1, 1')
      },
      width: layoutDesktop.width,
      height: layoutDesktop.height
    };
    widgetIds.push(uid);
    attachContainerLayouts.push(layoutForAttach);
    const newYMobile = getMobileLayoutY(widget) - minMobileYSelected;
    propertyLayouts.push({
      layout: {
        ...layoutMobile,
        transform: {
          ..._.get(layoutMobile, 'transform'),
          translate: `${xMobile}, ${newYMobile}px`
        }
      }
    });
  }

  /** Attach to the container and Update Mobile Property */  
  yield put(bulkAttachWidgetsToContainer(editorSession, selectionPageUid, widgetIds, attachContainerLayouts));

  yield put(updateBulkWidgetProperty(editorSession, widgetIds, 'mobile', propertyLayouts));

  const belowWidgetIds = [];
  const belowAttachContainerLayouts = [];
  const belowPropertyLayouts = [];
  
  for (const w of belowRoots) {
    const span = spanByUid[w.uid];
    if (!span) continue;
    
    // Get the actual layout Y position
    const currentLayoutY = getAbsoluteLayoutYInPage(w, pageId, widgets, 'desktop');

    // FIX: Subtract the layout offset, not the span offset
    const newY = currentLayoutY - selBottom;
    
    const layoutDesktop = _.get(w, 'properties.desktop.layout') || {};
    const translateDesktop =
      (layoutDesktop.transform && layoutDesktop.transform.translate) || '0px, 0px';
    const parts = translateDesktop.split(',').map(s => s.trim());
    const xDesktop = parts[0] || '0px';
    const layoutMobileBelow = _.get(w, 'properties.mobile.layout') || {};
    const translateMobileBelow =
      (layoutMobileBelow.transform && layoutMobileBelow.transform.translate) || '0px, 0px';
    const partsMBelow = translateMobileBelow.split(',').map(s => s.trim());
    const xMobileBelow = partsMBelow[0] || '0px';
    const layoutForAttach = {
      transform: {
        translate: `${xDesktop}, ${newY}px`,
        rotate: _.get(layoutDesktop, 'transform.rotate', '0deg'),
        scale: _.get(layoutDesktop, 'transform.scale', '1, 1')
      },
      width: layoutDesktop.width,
      height: layoutDesktop.height
    };
  
    belowWidgetIds.push(w.uid);
    belowAttachContainerLayouts.push(layoutForAttach);
  
    const newYMobile = getMobileLayoutY(w) - belowMinYMobile;
  
    belowPropertyLayouts.push({
      layout: {
        ...layoutMobileBelow,
        transform: {
          ..._.get(layoutMobileBelow, 'transform'),
          translate: `${xMobileBelow}, ${newYMobile}px`
        }
      }
    });
  }

  /** Attach to the container and Update Mobile Property */  

  if(belowWidgetIds?.length > 0) {
    yield put(bulkAttachWidgetsToContainer(editorSession, belowPageUid, belowWidgetIds, belowAttachContainerLayouts));

    yield put(updateBulkWidgetProperty(editorSession, belowWidgetIds, 'mobile', belowPropertyLayouts));
  }

  if (!shouldKeepPage) {
    yield put(deleteWidgets(editorSession, [pageId]));
  }

  const rootWidgets = yield select(state => {
    const ws = _.get(state, `${editorSession}.present.widgets`) || [];
    return ws.filter(item => !item.parent);
  });

  const beforeUids = orderedPages.slice(0, currentPageIndex).map(p => p.uid);
  const afterUids = orderedPages.slice(currentPageIndex + 1).map(p => p.uid);
  const desiredPageUids = [...beforeUids];
  if (shouldKeepPage) desiredPageUids.push(pageId);
  desiredPageUids.push(selectionPageUid);
  if (belowPageUid) desiredPageUids.push(belowPageUid);
  desiredPageUids.push(...afterUids);

  const desiredRoots = desiredPageUids
    .map(uid => rootWidgets.find(w => w.uid === uid))
    .filter(Boolean);
  const desiredUidSet = new Set(desiredRoots.map(w => w.uid));
  const nonPageRoots = rootWidgets.filter(w => !desiredUidSet.has(w.uid));
  desiredRoots.push(...nonPageRoots);

  if (desiredRoots.length > 0) {
    const request = desiredRoots.map((w, i) => ({
      uid: w.uid,
      order: desiredRoots.length - i
    }));
    yield put(bulkUpdateWidgetOrder(editorSession, request));
  }

  actionGroup.end();
  yield put(selectPageWidget(editorSession, selectionPageUid));
  yield put(selectWidget(editorSession, []));
}

function* clonePageSaga(action) {
  const { editorSession, page, cloneType } = action.payload;
  const pageId = editorSession.split("_")[1];
  const icPage = yield select((state) =>
      _.get(state, `pages.page.${pageId}.item`, [])
    );
  const variableMappings = _.get(icPage, "variableMappings", []);

  const _cleanData = (widget) => {
    const children = widget.widgets;
    if (_.size(children) > 0) {
      widget.widgets = children.map(child => _cleanData(child));
    }

    if (widget.properties && widget.properties.mobile) {
      widget.properties.mobile.disableOptimize = false;
    }

    return _.omit(widget, ['id', 'uid', 'parent', 'template']);
  }

  const newIndex = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);

    var pageWidgets = widgets.filter(item => item.type === PAGE);
    pageWidgets = _.orderBy(pageWidgets, 'order', 'desc');

    let oldIndex = pageWidgets.findIndex(item => item.uid === page);

    return SEGMENT_STORYBOARDS.includes(icPage.storyboardType) ? oldIndex + 1 :  oldIndex;
  })

  const clonedPage = yield select(state => {

    const widgets = _.get(state, `${editorSession}.present.widgets`);

    let pageWidget = widgets.find(item => item.uid === page);

    const _findChildren = (parent) => {
      return widgets.filter(widget => widget.parent === parent && !_.includes([CONTENT_CARD], widget.type));
    }

    const _buildCopyRequest = (widget) => {
      var widgetRequest = _.cloneDeep(widget);
      const widgetVariables = variableMappings.filter(vm => vm.widget === widget.uid);
      if (widgetVariables.length > 0) {
        widgetRequest.variableMappings = widgetVariables;
      }

      if (widgetRequest.type === CONTENT) {
        widgetRequest = _.omit(widget, ['content'])
      }

      // Clear action for carousel when cloning
      if (Array.isArray(widgetRequest.actions) && !cloneType) {
        const actions = widgetRequest.actions.filter(a => a.type === 'carousel');

        if(actions.length && widgetRequest.type === TEXT) {
          widgetRequest.content = widgetRequest.content.replace(/<a[^>]*>(.*?)<\/a>/g, '$1');
        }

        widgetRequest = {
          ...widgetRequest,
          actions: actions.length ? null : widgetRequest.actions
        };
      }

      var children = _findChildren(widget.uid);

      if (_.size(children) > 0) {
        widgetRequest.widgets = children
          .map(child => _buildCopyRequest(child))
          .sort((w1, w2) => {
            const o1 = _.get(w1, 'order') || 1;
            const o2 = _.get(w2, 'order') || 1;

            return o1 - o2;
          });
      }

      return widgetRequest;
    }

    var request = _buildCopyRequest(pageWidget);

    var cloned = _.cloneDeep(request);
    cloned = _cleanData(cloned);

    var uid = `widget_${shortid.generate()}`,

      cloned = {
        ...cloned,
        name: `Clone of ${cloned.name}`,
        uid: uid,
        properties: {
          ...cloned.properties,
          desktop: {
            ...cloned.properties.desktop,
            autoCreateAlias: true,
            alias: ''
          }
        }
      }

    return cloned;
  })

  if (!clonedPage) {
    return;
  }

  yield put(createWidget(editorSession, [clonedPage], null));

  yield put(arrangeWidget(editorSession, clonedPage, newIndex));

  const pageAdded = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    const pages = widgets.filter(page => {
      return page.type === PAGE;
    });

    const index = _.size(pages) - 1;
    return pages[index];
  });

  if (pageAdded) {
    yield put(switchInteractivePageSection(editorSession, pageAdded.uid));
  }
}

/**
 * Clone Side widget
 * 
*/

export const cloneSlider = createAction(EDITOR_CLONE_SLIDE, (editorSession, page) => {
  return {
    editorSession: editorSession,
    page: page
  }
})

function* cloneSliderSaga(action) {
  const { editorSession, page } = action.payload;
  const pageId = editorSession.split("_")[1];
  const spatialPage = yield select((state) =>
      _.get(state, `pages.page.${pageId}.item`, [])
    );
  const variableMappings = _.get(spatialPage, "variableMappings", []);

  const _cleanData = (widget) => {
    const children = widget.widgets;
    if (_.size(children) > 0) {
      widget.widgets = children.map(child => _cleanData(child));
    }

    if (widget.properties && widget.properties.mobile) {
      widget.properties.mobile.disableOptimize = false;
    }

    return _.omit(widget, ['id', 'uid', 'parent', 'template']);
  }

  const newIndex = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);

    var pageWidgets = widgets.filter(item => item.type === SLIDE);
    pageWidgets = _.orderBy(pageWidgets, 'order', 'desc');

    let oldIndex = pageWidgets.findIndex(item => item.uid === page);

    return oldIndex;
  })

  const clonedSlide = yield select(state => {

    const widgets = _.get(state, `${editorSession}.present.widgets`);

    let pageWidget = widgets.find(item => item.uid === page);

    const _findChildren = (parent) => {
      return widgets.filter(widget => widget.parent === parent && !_.includes([CONTENT_CARD], widget.type));
    }

    const _buildCopyRequest = (widget) => {
      var widgetRequest = _.cloneDeep(widget);

      if (widgetRequest.type === CONTENT) {
        widgetRequest = _.omit(widget, ['content'])
      }

      var children = _findChildren(widget.uid);
      const widgetVariables = variableMappings.filter(vm => vm.widget === widget.uid);
      if (widgetVariables.length > 0) {
        widgetRequest.variableMappings = widgetVariables;
      }

      if (_.size(children) > 0) {
        widgetRequest.widgets = children
          .map(child => _buildCopyRequest(child))
          .sort((w1, w2) => {
            const o1 = _.get(w1, 'order') || 1;
            const o2 = _.get(w2, 'order') || 1;

            return o1 - o2;
          });
      }

      return widgetRequest;
    }

    var request = _buildCopyRequest(pageWidget);

    var cloned = _.cloneDeep(request);
    cloned = _cleanData(cloned);

    var uid = `widget_${shortid.generate()}`,

      cloned = {
        ...cloned,
        name: `Clone of ${cloned.name}`,
        uid: uid,
      }

    return cloned;
  })

  if (!clonedSlide) {
    return;
  }

  yield put(createWidget(editorSession, [clonedSlide], null, false));

  yield put(arrangeWidget(editorSession, clonedSlide, newIndex));

  yield put(switchInteractivePageSection(editorSession, clonedSlide.uid));
}

/**
 * Arrange widgets in parent
 * 
*/
export const arrangeWidget = createAction(EDITOR_ARRANGE_WIDGETS, (editorSession, widget, index) => {
  return {
    editorSession: editorSession,
    widget: widget,
    index: index
  }
});

function* arrangeWidgetSaga(action) {
  const { editorSession, widget, index } = action.payload;

  const parent = _.get(widget, 'parent');

  var widgets = yield select(state => {
    var widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    widgets = widgets.filter(item => {
      if (parent) {
        return item.parent === parent;
      }

      return !item.parent;
    });
    widgets = _.orderBy(widgets, 'order', 'desc');
    return widgets;
  });

  if (_.size(widgets) === 0) {
    return;
  }

  const oldIndex = widgets.findIndex(item => item.uid === widget.uid);
  widgets.splice(oldIndex, 1);
  widgets.splice(index, 0, widget);

  var order = widgets.length + 1;
  const request = widgets.map((item) => {
    order = order - 1;

    return {
      uid: item.uid,
      order: order
    };
  });
  //Update the order
  yield put(bulkUpdateWidgetOrder(editorSession, request));
}

/**
 * Arrange carousel slides
 * 
*/
export const arrangeCarouselSlides = createAction(EDITOR_ARRANGE_CAROUSEL_WIDGETS, (editorSession, widget, index) => {
  return {
    editorSession: editorSession,
    widget: widget,
    index: index
  }
});

function* arrangeCarouselSlideSaga(action) {
  const { editorSession, widget, index } = action.payload;

  const parent = _.get(widget, 'parent');

  var widgets = yield select(state => {
    var widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    widgets = widgets.filter(item => {
      if (parent) {
        return item.parent === parent;
      }

      return !item.parent;
    });
    widgets = _.orderBy(widgets, 'order', 'asc');
    return widgets;
  });

  if (_.size(widgets) === 0) {
    return;
  }

  const oldIndex = widgets.findIndex(item => item.uid === widget.uid);
  widgets.splice(oldIndex, 1);
  widgets.splice(index, 0, widget);

  const request = widgets.map((item, index) => {

    return {
      uid: item.uid,
      order: index + 1
    };
  });

  //Update the order
  yield put(bulkUpdateWidgetOrder(editorSession, request));
}



/**
 * Align wigets
*/

export const alignWidgets = createAction(EDITOR_ALIGN_WIDGETS, (editorSession, breakpoint, type, direction,storyboardType, allWidgets) => {
  return {
    editorSession: editorSession,
    breakpoint: breakpoint,
    type: type,
    direction: direction,
    storyboardType: storyboardType,
    allWidgets: allWidgets
  }
});

function* alignWidgetsSaga(action) {
  const { editorSession, breakpoint, type, direction, storyboardType, allWidgets } = action.payload;

  const calculatePosition = (rect, type, direction) => {
    var size = 0;
    var start = 0;

    if (type === "horizontal") {
      size = rect.height;
      start = rect.y;
    } else {
      size = rect.width;
      start = rect.x;
    }

    if (direction === "center") {
      return start + size / 2;
    } else if (direction === "end") {
      return start + size;
    }

    return start;
  }

  const calculateRequestForWidgets = calculationByWidgetType(breakpoint, editorSession, calculatePosition, type, direction, storyboardType)

  //Fetch selected widgets
  const widgets = yield select(state => {
    const selected = _.get(state, `${editorSession}.present.selected`);

    if (_.size(selected) == 0) {
      return [];
    }

    const widgets = _.get(state, `${editorSession}.present.widgets`);

    return selected.map(id => {
      var widget = widgets.find(widget => widget.uid === id);
      if (!widget) {
        return null;
      }

      if (_.includes([PAGE, SECTION_COLUMN, MENU_CONTAINER], widget.type)) {
        return null;
      }

      return widget;
    }).filter(widget => widget != null);
  });

  if (_.size(widgets) == 0) {
    return;
  }

  var rect = yield call(getBoundingRectForWidgetsAlignment, editorSession, widgets, breakpoint);
  if (_.size(widgets) == 1) {
    const parent = yield select(state => {
      const id = widgets[0].parent;
      const widgetItems = _.get(state, `${editorSession}.present.widgets`) || [];
      return widgetItems.find(item => item.uid === id);
    });

    rect = yield call(getBoundingRectForWidgetsAlignment, editorSession, [parent], breakpoint);
  }

  const position = yield call(calculatePosition, rect, type, direction);
  const requests = yield call(calculateRequestForWidgets, widgets, position, allWidgets);

  if (_.size(requests) == 0) {
    return;
  }

  actionGroup.start();
  const actions = requests.map(({ id, frame }) => {
    return put(updateWidgetLayout(editorSession, id, breakpoint, frame.get()));
  });

  yield all(actions);
  actionGroup.end();
}

/**
 * Forms
 * 
*/
export const switchStepInForm = createAction(EDITOR_FORM_SWITCH_STEP, (editorSession, form, step) => {
  return {
    editorSession: editorSession,
    form: form,
    step: step
  };
})

export const insertFieldToForm = createAction(EDITOR_FORM_INSERT_FIELD, (editorSession, form, field) => {
  return {
    editorSession: editorSession,
    form: form,
    field: field
  };
});

function* insertFieldToFormSaga(action) {
  const { editorSession, form, field } = action.payload;

  const formWidget = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);
    return widgets.find(item => item.type === FORM && item.uid === form);
  });

  const formStep = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);
    const steps = widgets.filter(item => item.type === FORM_STEP && item.parent === form).sort((w1, w2) => {
      const o1 = _.get(w1, 'order') || 1;
      const o2 = _.get(w2, 'order') || 1;

      return o1 - o2;
    });

    const step = _.get(steps, '0');
    return step;
  });

  const widgets = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);
    const children = widgets.filter(item => item.parent === formStep.uid);
    return children;
  });

  const formFields = [FORM_FIELD, FORM_CHECK_BOX, FORM_DROPDOWN_LIST, FORM_CHECK_LIST, FORM_TEXTAREA, FORM_NUMBER, OTP_INPUT]

  const fields = yield select(state => {
    if (!formStep) {
      return [];
    }

    const fields = widgets.filter(item => _.includes(formFields, item.type) && item.parent === formStep.uid);
    return fields;
  });

  const sortedFields = sortWidgetsByPosition(editorSession, fields);
  var lastField = _.last(sortedFields);

  const moveRequests = yield call(moveWidgetsInForm, editorSession, widgets, lastField);
  const actions = moveRequests.map(request => {
    return put(request);
  });

  yield all(actions);

  const createRequest = createAddFieldRequest(editorSession, formWidget, field, lastField);
  yield put(createWidget(editorSession, [createRequest], formStep.uid));

  yield delay(1000);

  const childrenWidgets = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);
    const children = widgets.filter(item => item.parent === formStep.uid);
    return children;
  });

  const highestWidget = childrenWidgets.reduce((maxWidget, widget) => {
    const layout = _.get(widget, 'properties.mobile.layout');
    const rect = getBoundingRectFromLayout(layout);

    return !maxWidget || rect.y > maxWidget.rect.y ? { widget, rect } : maxWidget;
  }, null);

  const highestWidgetRect = highestWidget?.widget 
  ? getBoundingRectForWidget(editorSession, highestWidget.widget) 
  : null;

  const minFormHeightDesktop = (yield call(calculateHeightForWidget, editorSession, form, formStep.uid)) + 30;
  const minFormHeightMobile = highestWidgetRect ? highestWidgetRect.height + (highestWidget?.rect?.y || 0) + 30 : 0;

  const formLayoutDesktop = _.get(formWidget, 'properties.desktop.layout');
  const formLayoutMobile = _.get(formWidget, 'properties.mobile.layout');

  const formHeightDesktop = Math.max(getBoundingRectFromLayout(formLayoutDesktop).height, minFormHeightDesktop);
  const formHeightMobile = Math.max(getBoundingRectFromLayout(formLayoutMobile).height, minFormHeightMobile);

  yield put(updateWidgetLayout(editorSession, form, 'desktop', {
    ...formLayoutDesktop,
    height: `${formHeightDesktop}px`
  }));

  yield put(updateWidgetLayout(editorSession, form, 'mobile', {
    ...formLayoutMobile,
    height: `${formHeightMobile}px`
  }));
}


export const changeFieldType = createAction(EDITOR_FORM_FIELD_TYPE_CHANGE, (editorSession, form, field, currentField) => {
  return {
    editorSession: editorSession,
    form: form,
    field: field,
    currentField: currentField
  };
});

function* changeFieldTypeSaga(action) {
  const { editorSession, form, field, currentField } = action.payload;

  const formWidget = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);
    return widgets.find(item => item.type === FORM && item.uid === form);
  });

  const formStep = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`);
    const steps = widgets.filter(item => item.type === FORM_STEP && item.uid === form).sort((w1, w2) => {
      const o1 = _.get(w1, 'order') || 1;
      const o2 = _.get(w2, 'order') || 1;

      return o1 - o2;
    });

    const step = _.get(steps, '0');
    return step;
  });


  const createRequest = changeFieldTypeRequest(editorSession, formWidget, field, currentField);
  yield put(createWidget(editorSession, [createRequest], formStep.uid));
  yield put(deleteWidgets(editorSession, [currentField.uid]));
  yield delay(1000);

}

/**
 * Update Editor state for UI.
 * eg: Manage columns in section 
*/
export const updateWidgetEditorState = createAction(EDITOR_UPDATE_WIDGET_EDITOR_STATE, (editorSession, widget, editorState) => {
  return {
    editorSession: editorSession,
    widget: widget,
    editorState: editorState
  };
});

export const updateBulkWidgetsEditorState = createAction(EDITOR_BULK_UPDATE_WIDGET_EDITOR_STATE, (editorSession, widgets, editorState) => {
  return {
    editorSession: editorSession,
    widgetIds: widgets,
    editorState: editorState
  };
});

export const submitContactForm = createAction(SUBMIT_CONTACT_FORM, (editorSession, form) => {
  return {
    editorSession: editorSession,
    form: form,
  }
});

export const submitOtpForm = createAction(SUBMIT_OTP_FORM, (editorSession, form) => {
  return {
    editorSession: editorSession,
    form: form,
  }
});

export const otpResend = createAction(OTP_RESEND, (editorSession, form) => {
  return {
    editorSession: editorSession,
    form: form,
  }
});

/**
 * Update section columns width
*/
export const recalculateSectionColumnWidths = createAction(EDITOR_RECALCULATE_SECTION_COLUMN_WIDTHS, (editorSession, section) => {
  return {
    editorSession: editorSession,
    section: section
  }
});

function* recalculateSectionColumnWidthsSaga(action) {
  const { editorSession, section } = action.payload;

  const columns = yield select(state => {
    const widgets = _.get(state, `${editorSession}.present.widgets`) || [];
    const columns = widgets.filter(item => item.parent === section).filter(item => item.type === SECTION_COLUMN);
    return columns;
  });

  const width = 100 / _.size(columns);
  const layouts = columns.map(column => {
    return {
      id: column.uid,
      layout: {
        ..._.get(column, 'properties.desktop.layout'),
        width: `${width}%`,
      },
    }
  });

  actionGroup.start();

  yield put(bulkUpdateWidgetLayouts(editorSession, 'desktop', layouts));

  const containerRequests = columns.map(column => {
    const minWidth = 1200 * width / 100;
    return put(updateWidgetProperty(editorSession, column.uid, 'desktop', {
      container: {
        ..._.get(column, 'properties.desktop.container') || {},
        minWidth: minWidth
      }
    }));
  })

  yield all(containerRequests);

  actionGroup.end();
}

export const replaceWidgets = createAction(EDITOR_REPLACE_WIDGETS, (editorSession, widgets) => {
  return {
    editorSession: editorSession,
    widgets: widgets
  }
});

function* autoGrowLayoutSaga() {
  const channel = yield actionChannel(AUTO_GROW_LAYOUT_REQUEST);
  while (true) {
    const action = yield take(channel);
    yield call(autoGrowLayout, action);
  }
}

function* autoGrowLayout(action) {
  const { editorSession, breakpoint, widget, delta, parentEditorSession = {} } = action.payload;
  const { parentSelector = "" } = parentEditorSession;

  const widgets = yield select(state => _.get(state, `${editorSession}.present.widgets`) || []);
  const widgetsById = _.keyBy(widgets, 'uid');
  const autoGrowWidget = widgetsById[widget];

  const currentBreakpoint = yield select(state => _.get(state, `${editorSession}.present.breakpoint`));

  if (!autoGrowWidget) return;

  const { isGloballyAttachable, shouldSkipContainerUpdate, excludeWidgets } = getAutoGrowConfig(
    autoGrowWidget,
    widgetsById
  );

  const layout = _.get(autoGrowWidget, `properties.${breakpoint}.layout`);
  const rect = getBoundingRectFromLayout(layout);
  const referenceY = isGloballyAttachable ? getYForWidget(autoGrowWidget, widgetsById, breakpoint) + rect.height : rect.y;

  const ancestors = isGloballyAttachable ? getAllAncestors(autoGrowWidget, widgets, excludeWidgets) : [];
  const ancestorIdSet = new Set(ancestors.map(a => a.uid));
  const impactedWidgets = getImpactedWidgets({
    widgets,
    autoGrowWidget,
    ancestorIdSet,
    breakpoint,
    referenceY,
    isGloballyAttachable,
  });

  const changeRequest = {};
  if (isGloballyAttachable) {
    Object.assign(
      changeRequest,
      applyHeightChangesToAncestors(ancestors, autoGrowWidget, breakpoint, delta)
    );
  }

  Object.assign(changeRequest, getImpactedWidgetChanges({ impactedWidgets, breakpoint, delta }));

  const containerWidget = findContainerWidget(autoGrowWidget, widgetsById);
  const isLiveElementContainer = containerWidget?.type === LIVE_ELEMENT_CONTAINER;
  const shouldUpdateContainer = containerWidget && !shouldSkipContainerUpdate && !isLiveElementContainer;

  if (shouldUpdateContainer) {
    const containerLayout = _.get(containerWidget, `properties.${breakpoint}.layout`);
    const containerRect = getBoundingRectFromLayout(containerLayout);
    const frame = new Frame(containerLayout);
    if (frame.has('height')) {
      frame.set('height', `${containerRect.height + delta}px`);
    }
    changeRequest[containerWidget.uid] = {
      id: containerWidget.uid,
      path: `properties.${breakpoint}.layout`,
      value: frame.get(),
    };
  }

  if (isLiveElementContainer && parentSelector) {
    const parentWidgets = yield select(state => _.get(state, `${parentSelector}.present.widgets`) || []);
    if(isLiveElementInsideCarousel(containerWidget, parentWidgets) && isGloballyAttachable) return;
    const parentChanges = getLiveElementParentChanges(containerWidget, parentWidgets, breakpoint, delta);
    if (parentChanges && Object.keys(parentChanges).length > 0) {
      yield put(applyWidgetPropertyChanges(parentSelector, parentChanges, currentBreakpoint));
    }
  }

  // bypassLock: true so layout updates apply to locked widgets too
  yield put(applyWidgetPropertyChanges(editorSession, changeRequest, currentBreakpoint, [], true));
}

export const createHotspot = createAction(CREATE_HOTSPOT_WIDGET, (widget, editorSession) => {
  return {
    widget: widget,
    editorSession: editorSession
  }
})

function* createHotspotSaga(action) {
  const { widget, editorSession } = action.payload;

  const popupWidget = {
    type: POPUP,
    
  }
}

/*
* Generate Alt Text For Image Widget
*/
export const generateAltTextForWidget = createAction(GENERATE_ALT_TEXT_FOR_WIDGET_REQUEST, (uid, imageId, callback) => {
  return {
    uid: uid,
    imageId: imageId,
    callback: callback
  };
});

const generatingAltTextForWidgetSucceeded = createAction(GENERATING_ALT_TEXT_FOR_WIDGET_SUCCEEDED, (uid, imageId, response) => {
  return {
    uid: uid,
    imageId: imageId,
    response: response
  };
});

const generatingAltTextForWidgetFailed = createAction(GENERATING_ALT_TEXT_FOR_WIDGET_FAILED, (uid, imageId, error) => {
  return {
    uid: uid,
    imageId: imageId,
    error: error
  }
});

function* generateAltTextForWidgetSaga(action) {
  const { uid, imageId, callback } = action.payload;

  let params = {
    imageId: imageId
  };

  let url = buildUrl(WIDGET_URL, {
    path: `/${uid}/generate/alt/text`,
    queryParams: params
  });

  const generateAltTextForWidgetAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(generateAltTextForWidgetAPI);
    if (response) {
      yield put(generatingAltTextForWidgetSucceeded(uid, response));

      if(callback) {
        callback(response);
      }
    }
  } catch (error) {
    yield put(generatingAltTextForWidgetFailed(uid, error));

    if(callback) {
      callback(error);
    }
  }
}

/*
* Request for mobile optimization
*/
export const aiMobileOptimizationRequest = createAction(AI_MOBILE_OPTIMIZATION_REQUEST, (request, callback) => {
  return {
    request: request,
    callback: callback
  };
});

const aiMobileOptimizationSucceeded = createAction(AI_MOBILE_OPTIMIZATION_SUCCEEDED, (response) => {
  return {
    response: response
  };
});

const aiMobileOptimizationFailed = createAction(AI_MOBILE_OPTIMIZATION_FAILED, (error) => {
  return {
    error: error
  }
});

function* aiMobileOptimizationSaga(action) {
  const { request, callback } = action.payload;

  const aiMobileOptimizationAPI = () => {
    return axios.post(OPTIMIZE_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(aiMobileOptimizationAPI);
    if (response) {
      yield put(aiMobileOptimizationSucceeded(response));

      if(callback) {
        callback(response);
      }
    }
  } catch (error) {
    yield put(aiMobileOptimizationFailed(error));

    if(callback) {
      callback(error);
    }
  }
}

// COPY PASTE ANIMATION
export const copyPasteAnimation = createAction(COPY_PASTE_EDITOR_ANIMATION, (request, callback) => {
  return {
    request,
    callback
  };
});

function* copyPasteAnimationSaga(action) {
  const { request, callback } = action.payload || {};
  const { type, exit, storyboardId, workspaceId, editorSession } = request || {};

  const selectedWidgets = yield select(state => {
    const selected = _.get(state, `${editorSession}.present.selected`);

    if (_.size(selected) == 0) {
      return [];
    }

    const widgets = _.get(state, `${editorSession}.present.widgets`);

    return selected.map(id => {
      return widgets.find(widget => widget.uid === id);
    }).filter(widget => widget != null);
  });
  const currentBreakpoint = yield select(state => _.get(state, `${editorSession}.present.breakpoint`));

  if(selectedWidgets.length < 1) return;
  
  if(type === 'copy') {
    const widget = selectedWidgets[0];
    const animation = _.get(widget, `properties.${currentBreakpoint}.animation`, null) || null;
    const exitAnimation = _.get(widget, `properties.${currentBreakpoint}.exitAnimation`, null) || null;

    if (!animation && !exitAnimation) {
      return;
    }

    window.localStorage.setItem('CLIPBOARD_ANIMATION', JSON.stringify({
      storyboard: storyboardId,
      workspace: workspaceId,
      animation: exit ? exitAnimation : animation,
      widgetType: widget.type
    }));

    callback('copy');
    return;
  }

  // PASTE ANIMATION

  const clipboardData = window.localStorage.getItem('CLIPBOARD_ANIMATION');
  const clipboardAnimation = clipboardData ? JSON.parse(clipboardData) : null;

  const hotspot = selectedWidgets.find(w => w.type === HOTSPOT);

  const widgetIds = selectedWidgets.map(w => w.uid);

  // HOTSPOT only allow single selection
  if(hotspot) {
    const widgetId = _.get(hotspot, 'uid') || '';

    if(exit) {
      yield put(
        updateWidgetProperty(editorSession, widgetId, currentBreakpoint, {
          ['exitAnimation']: clipboardAnimation?.animation || null,
        })
      );
    } else {
      yield put(
        updateWidgetProperty(editorSession, widgetId, currentBreakpoint, {
          ['animation']: clipboardAnimation?.animation || null,
        })
      );
    }
  } else {
    // BULK ANIMATION UPDATE
    yield put(
      updateBulkWidgetProperty(editorSession, widgetIds, currentBreakpoint, {
        ['animation']: clipboardAnimation.animation,
      })
    );
  }

  callback('paste');
}

// ============================================================================
// Create Widgets For Prompt Sections
// ============================================================================

export const createWidgetsForPromptSections = createAction(
  CREATE_WIDGETS_FOR_PROMPT_SECTIONS, 
  (editorSession, sectionData, storyboardId) => ({
    editorSession,
    sectionData,
    storyboardId
  })
);

export const processPromptWidget = createAction(
  PROCESS_PROMPT_WIDGET_REQUEST,
  (editorSession, widgetId, section, apiEndpoint) => ({
    editorSession,
    widgetId,
    section,
    apiEndpoint
  })
);

export const processPromptWidgetSucceeded = createAction(
  PROCESSING_PROMPT_WIDGET_SUCCEEDED,
  (editorSession, widgetId, apiEndpoint, response) => ({
    editorSession,
    widgetId,
    apiEndpoint,
    response
  })
);

export const processPromptWidgetFailed = createAction(
  PROCESSING_PROMPT_WIDGET_FAILED,
  (editorSession, widgetId, apiEndpoint, error) => ({
    editorSession,
    widgetId,
    apiEndpoint,
    error
  })
);

export const processAllPromptWidgetsCompleted = createAction(
  PROCESS_ALL_PROMPT_WIDGETS_COMPLETED,
  (editorSession) => ({
    editorSession
  })
);

export const updateAiImageWidgetContent = createAction(
  UPDATE_AI_IMAGE_WIDGET_CONTENT,
  (editorSession, widgetId, imageData) => ({
    editorSession,
    widgetId,
    imageData,
  })
);

export const updateAiWidgetBackground = createAction(
  UPDATE_AI_WIDGET_BACKGROUND,
  (editorSession, widgetId, imageData) => ({
    editorSession,
    widgetId,
    imageData,
  })
);

function* createWidgetsForPromptSectionsSaga(action) {
  const { editorSession, sectionData, storyboardId } = action.payload;
  const sections = sectionData.pageStructure.sections;

  try {
    // Clear existing widgets
    const existingWidgets = yield select(
      state => _.get(state, `${editorSession}.present.widgets`, [])
    );

    if (existingWidgets.length > 0) {
      yield put(deleteWidgets(editorSession, existingWidgets.map(w => w.uid)));
    }

    const frameId = `widget_${shortid.generate()}`;
    const finalSections = [sections[0]];

    const widgets = [{
      ...NEW_SEGMENT,
      uid: frameId,
      order: 0,
      widgets: finalSections.map((section, index) => ({
        type: PROMPT_WIDGET,
        name: section.name || 'Prompt Section',
        uid: `widget_${shortid.generate()}`,
        parent: frameId,
        content: sections,
        order: index
      }))
    }];

    yield put(createWidget(editorSession, widgets, null));
    yield put(createWidgetFromHTML(editorSession, sectionData, frameId, storyboardId));

    // const apiEndpoints = [
    //   '/layout-content',
    //   '/layout-builder',
    //   '/desktop-improvement',
    // ];

    // // All sections run in parallel; endpoints within each section run sequentially
    // yield all(
    //   widgetSectionMap.map(({ widgetId, section }) =>
    //     call(processWidgetSequentially, editorSession, widgetId, section, apiEndpoints, sectionData, storyboardId)
    //   )
    // );
    clearPromptEditorDataFromStorage();
  } catch (error) {
    console.error('Error in createWidgetsForPromptSectionsSaga:', error);
    yield put(processAllPromptWidgetsCompleted(editorSession));
    clearPromptEditorDataFromStorage();
  }
}

function clearPromptEditorDataFromStorage() {
  try {
    localStorage.removeItem('promptEditorData');
    localStorage.removeItem('aiTheme');

    if (typeof window !== 'undefined' && window.location?.search?.includes('isPromptEditor')) {
      const url = new URL(window.location.href);
      url.searchParams.delete('isPromptEditor');
      const cleanUrl = url.search ? `${url.pathname}${url.search}` : url.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  } catch (e) {
    console.warn('Failed to clear prompt editor storage:', e);
  }
}

export const updateAiImageWidgetContentFailed = createAction(
  UPDATE_AI_IMAGE_WIDGET_CONTENT_FAILED,
  (editorSession, widgetId) => ({
    editorSession,
    widgetId,
  })
);

export const createWidgetFromHTML = createAction(CREATE_WIDGET_FROM_HTML_REQUEST, (editorSession, sectionData, storyboardId) => ({
  editorSession,
  sectionData,
  storyboardId
}));

const createWidgetFromHTMLSucceeded = createAction(CREATE_WIDGET_FROM_HTML_SUCCEEDED, (response) => ({
  response
}));

const createWidgetFromHTMLFailed = createAction(CREATE_WIDGET_FROM_HTML_FAILED, (editorSession, error) => ({
  editorSession,
  error
}));

function* createWidgetFromHTMLSaga(action) {
  const { editorSession, sectionData, storyboardId } = action.payload;
  const sections = sectionData.pageStructure.sections;
  const existingWidgets = yield select( state => _.get(state, `${editorSession}.present.widgets`, []));

    if (existingWidgets.length > 0) {
      yield put(deleteWidgets(editorSession, existingWidgets.map(w => w.uid)));
    }
    const sectionsToProcess = [...sections].reverse();

    const widgets = sectionsToProcess.flatMap((section, index) => {
      const frameId = `widget_${shortid.generate()}`;
      const sectionWidgetId = `widget_${shortid.generate()}`;

      return [{
        ...NEW_SEGMENT,
        uid:     frameId,
        order:   index,
        widgets: [{
          type:    PROMPT_WIDGET,
          name:    section.name || 'Prompt Section',
          uid:     sectionWidgetId,
          parent:  frameId,
          content: section,
        }],
      }];
    });

    yield put(createWidget(editorSession, widgets, null));

  const request = {
    prompt: sectionData.prompt,
    session: sectionData.session,
    sections: JSON.stringify({
      sections: sectionData.pageStructure.sections.map(section => ({
        name: section.name,
        plan: section.plan
      }))
    }),
    storyboardId: storyboardId
  };

  const pagewidgets = widgets.map((widget) => {
    widget.content = widget.widgets[0].content.name;
    widget.widgets = [];
    return widget;
  }
  );

  const createWidgetFromHTMLAPI = () => {
    return axios.post(`${PYTHON_PROMPT_EDITOR_URL}/page-generator`, request).then(response => response.data);
  }

  try {
    const response = yield call(createWidgetFromHTMLAPI);
    clearPromptEditorDataFromStorage();
    yield put(createWidgetFromHTMLSucceeded(response));
    const htmlContent = response.answer;

    if (htmlContent) {
      yield put(processHTMLToWidget(editorSession, pagewidgets, htmlContent, storyboardId, sectionData));
    }
  } catch (error) {
    console.error('Error in createWidgetFromHTMLSaga:', error);
    yield put(createWidgetFromHTMLFailed(editorSession, error.message || error));
  }
}

const processHTMLToWidget = createAction(PROCESS_HTML_TO_WIDGET_REQUEST, (editorSession, pageWidgets, htmlContent, storyboardId, sectionData) => ({
  editorSession,
  pageWidgets,
  htmlContent,
  storyboardId,
  sectionData
}));

function* processHTMLToWidgetSaga(action) {
  const { editorSession, pageWidgets, htmlContent, storyboardId, sectionData } = action.payload;

  try {
    if (!htmlContent) {
      console.warn('No HTML content provided for widget: skipping processing.');
      return;
    }
    const trimmed = htmlContent.trim();
    if (!trimmed) return;
    const result = yield call(extractWidgetsFromHTML, trimmed);
    const {widgets, updatedPageWidgets} = result;
    const mergedWidgets = [...widgets, ...updatedPageWidgets];
    const finalWidgets = prepareWidgetCopyRequest(mergedWidgets);
    const existingWidgets = yield select(
      state => _.get(state, `${editorSession}.present.widgets`, [])
    );
    if (finalWidgets.length > 0) {
      if (existingWidgets.length > 0) {
        yield put(deleteWidgets(editorSession, existingWidgets.map(w => w.uid)));
      }
      yield put(createWidget(editorSession, finalWidgets, null, false));
      const aiImageWidgets = (widgets || []).filter(w => w.type === AI_IMAGE_WIDGET);
      if (aiImageWidgets.length > 0) {
        yield call(processAiImageWidgets, editorSession, aiImageWidgets, sectionData, storyboardId);
      }
      yield put(processAllPromptWidgetsCompleted(editorSession));

    }

  } catch (error) {
    console.error('Error in processHTMLToWidgetSaga:', error);
  }
}

export function prepareWidgetCopyRequest(widgets) {
    
  const _findWidget = (id) => {
    return widgets.find(widget => widget.uid === id);
  }

  const _findChildren = (parent) => {
    return widgets.filter(widget => widget.parent === parent);
  }

  const reCalculateWidgetLayout = (widget, layout, breakpoint) => {
    var wRect = getBoundingRectFromLayout(layout);

    var parent = _findWidget(widget.parent);

    const frame = new Frame(layout);

    var pRectX = 0
    var pRectY = 0

    var x = wRect.x + pRectX;
    var y = wRect.y + pRectY;

    const translate = `${x}px, ${y}px`;

    frame.set("transform", "translate", translate);
    var updatedLayout = frame.get();

    if (parent) {
      return reCalculateWidgetLayout(parent, updatedLayout, breakpoint);
    }

    return updatedLayout;
  }

  const _buildCopyRequest = (widget, calculateLayout) => {
    var widgetRequest = _.cloneDeep(widget);
    var children = _findChildren(widget.uid);
    var parent = _findWidget(widget.parent);

    if (parent) {
      let desktopLayout = reCalculateWidgetLayout(widget, _.get(widget, `properties.desktop.layout`), 'desktop');

      let mobileLayout = reCalculateWidgetLayout(widget, _.get(widget, `properties.mobile.layout`), 'mobile');


      widgetRequest = {
        ...widgetRequest,
        properties: {
          ...widgetRequest.properties,
          desktop: {
            ...widgetRequest.properties.desktop,
            layout: desktopLayout
          },
          mobile: {
            ...widgetRequest.properties.mobile,
            layout: mobileLayout
          }
        }
      }
    }

    if (_.size(children) > 0) {
      widgetRequest.widgets = children
        .map(child => _buildCopyRequest(child, false))
        .sort((w1, w2) => {
          const o1 = _.get(w1, 'order') || 1;
          const o2 = _.get(w2, 'order') || 1;

          return o1 - o2;
        });
    }

    return widgetRequest;
  }

  const selected = widgets.filter(widget => !_findWidget(widget.parent));

  var processedWidgets = selected.filter(widget=> ![SECTION_COLUMN].includes(widget.type)).map(widget => _buildCopyRequest(widget, true));

  return processedWidgets;
};

function* processWidgetSequentially(editorSession, widgetId, section, apiEndpoints, sectionData, storyboardId) {
  for (const apiEndpoint of apiEndpoints) {
    yield call(processWidgetApiCall, editorSession, widgetId, section, apiEndpoint, sectionData, storyboardId);
  }
}

function* processWidgetApiCall(editorSession, widgetId, section, apiEndpoint, sectionData, storyboardId) {
  try {
    yield put(processPromptWidget(editorSession, widgetId, section, apiEndpoint));

    const widgets       = yield select(state => _.get(state, `${editorSession}.present.widgets`, []));
    const currentWidget = widgets.find(w => w.uid === widgetId);
    const currentContent = _.get(currentWidget, 'content', section);

    // Build payload based on endpoint
    let payload, requestConfig;

    if (apiEndpoint === '/desktop-improvement') {
      const pageWidget = widgets.find(w => w.uid === currentWidget.parent);
      if (!pageWidget) throw new Error('Page widget not found for desktop-improvement');

      ({ payload, requestConfig } = yield call(buildDesktopImprovementPayload, {
        sectionData,
        currentContent,
        storyboardId,
        pageWidget,
        widgets,
      }));

    } else {
      const result = buildApiPayload(apiEndpoint, { sectionData, section, currentContent, storyboardId });
      if (!result) throw new Error(`Unknown apiEndpoint: ${apiEndpoint}`);
      ({ payload, requestConfig } = result);
    }

    // let data;
    // if (requestConfig?.__mock) {
    //   data = requestConfig.data; // ← use mock data directly
    // } else {
    //   const response = yield call(axios.post, `${PROMPT_EDITOR_URL}${apiEndpoint}`, payload, requestConfig);
    //   data = response.data;
    // }

    const { data } = yield call(axios.post, `${PROMPT_EDITOR_URL}${apiEndpoint}`, payload, requestConfig);

    // Parse HTML response into widgets for layout-builder and desktop-improvement
    if (apiEndpoint === '/layout-builder' || apiEndpoint === '/desktop-improvement') {
      const pageWidget = widgets.find(w => w.uid === currentWidget.parent);
      if (pageWidget) {
        parseResponseWidgets(data, pageWidget);
      }
    }
    const imagePrompts = currentContent?.section?.content?.image_prompts || [];

    yield put(processPromptWidgetSucceeded(editorSession, widgetId, apiEndpoint, data));

    // if (apiEndpoint === '/layout-builder') {
    //   const aiImageWidgets = (data.widgets || []).filter(w => w.type === AI_IMAGE_WIDGET);
    //   const imagePrompts = currentContent.section?.content?.image_prompts || [];
      
    //   // console.log('[DEBUG] aiImageWidgets:', aiImageWidgets.map(w => ({ uid: w.uid, promptId: w.content?.promptId })));
    //   // console.log('[DEBUG] imagePrompts:', imagePrompts.map(p => ({ uid: p.uid, prompt: p.prompt?.slice(0, 50) })));
    //   // console.log('[DEBUG] matches:', aiImageWidgets.map(w => ({
    //   //   widgetId: w.uid,
    //   //   promptId: w.content?.promptId,
    //   //   matched: imagePrompts.find(p => p.uid === w.content?.promptId) ? 'YES' : 'NO'
    //   // })));
    
    //   yield spawn(processAiImageWidgets, editorSession, aiImageWidgets, imagePrompts, sectionData, storyboardId);
    // }

    if (apiEndpoint === '/desktop-improvement') {
      const aiImageWidgets = (data.widgets || []).filter(w => w.type === AI_IMAGE_WIDGET);
      const BACKGROUND_WIDGET_TYPES = new Set([
        "cleverstory.v2.widgets.page",
        "cleverstory.v2.widgets.section",
        "cleverstory.v2.widgets.section.column",
      ]);
      const backgroundWidgets = (data.widgets || []).filter(
        w => BACKGROUND_WIDGET_TYPES.has(w.type) && w.content?.backgroundPromptId
      );

      yield spawn(processBackgroundImageWidgets, editorSession, backgroundWidgets, imagePrompts, sectionData, storyboardId);
      yield spawn(processAiImageWidgets, editorSession, aiImageWidgets, imagePrompts, sectionData, storyboardId);
    }

  } catch (error) {
    console.error(`Error in ${apiEndpoint}:`, error);
    yield put(processPromptWidgetFailed(editorSession, widgetId, apiEndpoint, error.message || error));
  }
}

function* processAiImageWidgets(editorSession, aiImageWidgets, sectionData, storyboardId) {
  const tasks = aiImageWidgets.map((imageWidget) => {
    const prompt = imageWidget.content?.prompt;
    const aspectRatio = imageWidget.content?.aspectRatio;

    if (!prompt) {
      console.warn(`No image prompt found for promptId: imageWidget ${imageWidget.uid}`);
      return null;
    }

    return call(
      processImageGeneratorForWidget,
      editorSession,
      imageWidget.uid,
      prompt,
      sectionData,
      storyboardId,
      aspectRatio
    );
  }).filter(Boolean);

  yield all(tasks);
}

function* processImageGeneratorForWidget(
  editorSession,
  imageWidgetId,
  matchedPrompt,
  sectionData,
  storyboardId,
  aspectRatio
) {
  try {
    const payload = {
      prompt: matchedPrompt,
      aspectRatio: aspectRatio,
      storyboardId: storyboardId
    };

    const response = yield call(
      axios.post,
      `${PROMPT_EDITOR_URL}/image-generator-new`,
      payload,
      { responseType: "blob" }
    );

    const blob = response.data;
    const contentType =
      response.headers["content-type"] || "application/octet-stream";

    const file = new File([blob], "ai-image.png", {
      type: contentType
    });

    yield put(
      updateAiImageWidgetContent(editorSession, imageWidgetId, file)
    );

  } catch (error) {
    console.error(
      `Error generating background image for widget ${imageWidgetId}:`,
      error
    );
    yield put(updateAiImageWidgetContentFailed(editorSession, imageWidgetId));
  }
}

function* processBackgroundImageWidgets(editorSession, backgroundWidgets, imagePrompts, sectionData, storyboardId) {
  const tasks = backgroundWidgets.map((widget) => {
    const promptId = widget.content?.backgroundPromptId;
    const matchedPrompt = imagePrompts.find(p => p.uid === promptId);

    if (!matchedPrompt) {
      console.warn(`No image prompt found for background promptId: ${promptId}`);
      return null;
    }

    return call(
      processBackgroundImageForWidget,
      editorSession,
      widget.uid,
      matchedPrompt,
      sectionData,
      storyboardId
    );
  }).filter(Boolean);

  yield all(tasks);
}

function* processBackgroundImageForWidget(editorSession, widgetId, matchedPrompt, sectionData, storyboardId) {
  try {
    const payload = {
      prompt: sectionData.prompt,
      session: sectionData.session,
      storyboardId,
      content: JSON.stringify([{ prompt: matchedPrompt.prompt, uid: matchedPrompt.uid }]),
    };

    const { data } = yield call(axios.post, `${PROMPT_EDITOR_URL}/image-generator`, payload, {});

    // Dispatch a dedicated action to update background (not widget content)
    yield put(updateAiWidgetBackground(editorSession, widgetId, data));

  } catch (error) {
    console.error(`Error generating background image for widget ${widgetId}:`, error);
  }
}

// ============================================================================
// HELPERS for Create Widgets For Prompt Sections
// ============================================================================

const buildApiPayload = (apiEndpoint, { sectionData, section, currentContent, storyboardId }) => {
  const base = {
    prompt: sectionData.prompt,
    session: sectionData.session,
  };
  switch (apiEndpoint) {
    case '/layout-content':
      return {
        payload: {
          ...base,
          ai_theme: sectionData.ai_theme || '698dc58255d4ca02b20e3084',
          sections: JSON.stringify(section),
        },
        requestConfig: {},
      };
    case '/layout-builder':
      return {
        payload: {
          ...base,
          section_id: currentContent.section?.layout_id || '698b02c5ef593226ead1cc45',
          sectionPlan: JSON.stringify(currentContent.section),
        },
        requestConfig: {},
      };

    default:
      return null;
  }
};

function* buildDesktopImprovementPayload({ sectionData, currentContent, storyboardId, pageWidget, widgets }) {

  const desktopHtml = currentContent.sectionPlan || '';

  const filteredWidgets = widgets
    .filter(w => w.parent != null && w.parent === pageWidget.uid)
    .sort((a, b) => a.order - b.order);

  const [pageDesktopHTML, desktopImage] = yield all([
    call(generateHTML, filteredWidgets, pageWidget, 'desktop', storyboardId),
    call(generateImageSnapshot, pageWidget, 'mobile'),
  ]);

  const request = {
    storyboardId,
    prompt: sectionData.prompt,
    session: sectionData.session,
    section_id: currentContent.section?.layout?.id || '698b02c5ef593226ead1cc45',
    desktopHtml,
    pageDesktopHtml: pageDesktopHTML,
    pageWidgetId: pageWidget.uid,
  };

  const formData = new FormData();
  formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));
  formData.append('desktopImage', desktopImage);

  return {
    payload: formData,
    requestConfig: { headers: { 'Content-Type': 'multipart/form-data' } },
  };
}

function parseResponseWidgets(data, pageWidget) {
  if (!data.answer) return;

  const { widgets: parsedWidgets, pageProperties } = parseHtmlToWidgets(data.answer, pageWidget);
  const imageWidgets = parsedWidgets.filter(w => w.type === AI_IMAGE_WIDGET);
  data.widgets = parsedWidgets;
  data.pageProperties = pageProperties;
}

// const buildApiPayload = (apiEndpoint, { sectionData, section, currentContent, storyboardId }) => {
//   const base = {
//     prompt: sectionData.prompt,
//     session: sectionData.session,
//   };

//   // ============================================================
//   // LOCAL DEBUG MOCKS - remove before production
//   // ============================================================
//   if (process.env.NODE_ENV === 'development') {
//     if (apiEndpoint === '/layout-content') {
//       return {
//         payload: null,
//         requestConfig: {...SectionBackgroundLayoutConfig, session: sectionData.session},
//       };
//     }

//     if (apiEndpoint === '/layout-builder') {
//       return {
//         payload: null,
//         requestConfig: { __mock: true, data: {
//           answer: SectionBackgroundHTML,
//         }},
//       };
//     }
//   }
// };


export default function* editorSaga() {
  yield takeEvery(EDITOR_DELETE_WIDGET, deleteWidgetsSaga);
  yield takeEvery(EDITOR_SELECT_WIDGET_REQUEST, selectWidgetSaga);
  yield takeEvery(EDITOR_SELECT_ALL_WIDGETS, selectAllWidgetsSaga);
  yield takeEvery(EDITOR_UPDATE_WIDGET_LAYOUT, updateWidgetLayoutSaga);
  yield takeEvery(EDITOR_UPDATE_WIDGET_PROPERTY, updateWidgetPropertySaga);
  yield takeEvery(EDITOR_BULK_UPDATE_WIDGET_PROPERTY, updateBulkWidgetsPropertySaga);

  yield takeEvery(EDITOR_BULK_UPDATE_WIDGET_LAYOUT, bulkUpdateWidgetLayoutSaga);
  yield takeEvery(EDITOR_BULK_UPDATE_WIDGET_ORDER, bulkUpdateWidgetOrderSaga);
  yield takeEvery(EDITOR_UPDATE_WIDGET_ACTIONS, updateWidgetActionsSaga);
  yield takeEvery(EDITOR_UPDATE_WIDGET_NAME, updateWidgetNameSaga);

  yield takeEvery(EDITOR_RECALCULATE_LAYOUT, recalculateLayoutSaga);
  yield takeEvery(EDITOR_INTERACTIVE_CONTENT_CREATE_PAGE, createInteractivePageSectionSaga);
  yield takeEvery(EDITOR_COPY_WIDGETS, copyWidgetsSaga);
  yield takeEvery(EDITOR_CUT_WIDGETS, copyWidgetsSaga);
  yield takeEvery(EDITOR_CLONE_WIDGETS, cloneWidgetsSaga);
  yield takeEvery(EDITOR_CREATE_SEGMENT, createPageSegmentSaga);
  yield takeEvery(EDITOR_SPLIT_PAGE_BY_SELECTION, splitPageBySelectionSaga);
  yield takeEvery(EDITOR_CLONE_PAGE, clonePageSaga);
  yield takeEvery(EDITOR_CLONE_SLIDE, cloneSliderSaga);
  yield takeEvery(EDITOR_ARRANGE_WIDGETS, arrangeWidgetSaga);
  yield takeEvery(EDITOR_ARRANGE_CAROUSEL_WIDGETS, arrangeCarouselSlideSaga);
  yield takeEvery(EDITOR_ALIGN_WIDGETS, alignWidgetsSaga);
  yield takeEvery(EDITOR_CREATE_WIDGET, handleVariableMappingSaga);
  yield takeEvery(EDITOR_FORM_INSERT_FIELD, insertFieldToFormSaga);
  yield takeEvery(EDITOR_FORM_FIELD_TYPE_CHANGE, changeFieldTypeSaga);

  yield takeEvery(EDITOR_RECALCULATE_SECTION_COLUMN_WIDTHS, recalculateSectionColumnWidthsSaga);
  yield takeLatest([EDITOR_CREATE_WIDGET, EDITOR_DELETE_WIDGET, EDITOR_ATTACH_TO_CONTAINER, EDITOR_BULK_ATTACH_TO_CONTAINER, EDITOR_UPDATE_SPATIAL_SETTING_MODE, EDITOR_UPDATE_FLIPBOOK_SETTING_MODE], widgetLayoutChangesIndicatorSaga);
  yield fork(autoGrowLayoutSaga);
  yield takeEvery(GENERATE_ALT_TEXT_FOR_WIDGET_REQUEST, generateAltTextForWidgetSaga);
  yield takeEvery(AI_MOBILE_OPTIMIZATION_REQUEST, aiMobileOptimizationSaga);
  yield takeEvery(COPY_PASTE_EDITOR_ANIMATION, copyPasteAnimationSaga);
  yield takeEvery(CREATE_WIDGET_FROM_HTML_REQUEST, createWidgetFromHTMLSaga);
  yield takeEvery(PROCESS_HTML_TO_WIDGET_REQUEST, processHTMLToWidgetSaga);
  yield takeLatest(CREATE_WIDGETS_FOR_PROMPT_SECTIONS, createWidgetsForPromptSectionsSaga);
  yield takeEvery(EDITOR_ATTACH_TO_CONTAINER, showAutoGrowDisabledToastSaga);
};

export const actionGroup = {
  _group: null,
  start(group = shortid.generate()) {
    this._group = group
  },
  end() {
    this._group = null
  },
  init(rawActions) {
    const defaultGroupBy = groupByActionTypes(rawActions)
    return (action) => this._group || defaultGroupBy(action)
  }
};